import {
  Divider,
  Checkbox,
  InputLabel,
  useTheme,
  MenuItem,
  Paper,
  Menu,
  Box,
  Button,
  Breadcrumbs,
  TextField,
  Stack,
  IconButton,
  Avatar,
  FormLabel,
  FormControl,
  Typography,
  FormControlLabel,
  Select,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Formik, Field } from "formik";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import store from "../../../index";
import {
  explorePostData,
  fetchApidata,
  postApidata,
  postApidatawol,
  getDeployment,
  postDeployment,
  invoiceExploreGetData,
  postData,
  getFetchData,
  ResignationPOST,
  getResignation,
} from "../../../store/reducers/Formapireducer";
import { fnFileUpload } from "../../../store/reducers/Imguploadreducer";
import { fetchComboData1 } from "../../../store/reducers/Comboreducer";
import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-hot-toast";
import basicSchema, {
  companySchema,
  contactshema,
} from "../../Security/validation";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Listviewpopup from "../Lookup";
import Popup from "../popup";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { tokens } from "../../../Theme";

import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import {
  DataGrid,
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { imageUpload } from "../../../store/reducers/Imguploadreducer";
import { Productautocomplete } from "../../../ui-components/global/Autocomplete";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import { getConfig } from "../../../config";
// ***********************************************
//  Developer:Gowsalya
// Purpose:To Create Employee

// ***********************************************
const Editemployee = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const listViewData = useSelector((state) => state.listviewApi.rowData);
  const listViewcolumn = useSelector((state) => state.listviewApi.columnData);
  const [pageSize, setPageSize] = React.useState(10);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const [selectedCustomerOptions, setSelectedCustomerOptions] = useState(null);
  const [selectedManagerOptions, setSelectedManagerOptions] = useState(null);
  const [selectedManagerid, setSelectedManagerid] = useState(null);
  const [selectedManagerName, setSelectedManagerName] = useState(null);
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const handleFormSubmit = (values) => {
    console.log(values);
  };
  const YearFlag = sessionStorage.getItem("YearFlag");



  const config = getConfig();
  const baseurl1 = config.BOS_URL;
  console.log(baseurl1, "url path");

  const navigate = useNavigate();
  let params = useParams();
  const dispatch = useDispatch();
  var recID = sessionStorage.getItem("EmpId");
  var compID = sessionStorage.getItem("companyId");
  var mode = params.Mode;
  var accessID = params.accessID;
  const Data = useSelector((state) => state.formApi.Data);
  console.log("🚀 ~ Editemployee ~ Data:", Data);
  const Status = useSelector((state) => state.formApi.Status);
  const Msg = useSelector((state) => state.formApi.msg);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const isLoading = useSelector((state) => state.formApi.loading);

  const deploymentData = useSelector((state) => state.formApi.deploymentData);
  //  console.log("deploymentData",deploymentData);
    const ResignationGetData = useSelector((state) => state.formApi.ResignationGetData);
  console.log("ResignationGetData", ResignationGetData);
  
  const DataExplore = useSelector((state) => state.formApi.inviceEData);

  const [openDEPopup, setOpenDEPopup] = useState(false);
  const [openLOCATIONPopup, setOpenLOCATIONPopup] = useState(false);
  const [openGATEPopup, setOpenGATEPopup] = useState(false);

  const [openPROPopup, setOpenPROPopup] = useState(false);

  const [Color, setColor] = useState("");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const [errorMsgData, setErrorMsgData] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID }));
  }, []);
  const [ini, setIni] = useState(true);
  const [iniProcess, setIniProcess] = useState(true);
  const [loading, setLoading] = useState(false);
  var userimg = "https://hr.beyondexs.com/uploads/images/";
  if (mode == "A") {
    userimg = userimg + "Defaultimg.jpg";
  } else {
    if (
      Data.ImageName == undefined ||
      Data.ImageName == null ||
      Data.ImageName == ""
    ) {
      userimg = userimg + "Defaultimg.jpg";
    } else {
      userimg = userimg + Data.ImageName;
    }
  }

  var apiData = "";
  apiData = {
    Code: Data.Code,
    Name: Data.Name,
    Job: Data.Job,
    Comm: Data.Comm,
    Mgr: Data.Mgr,
    Sal: Data.Sal,
    Fax: Data.Fax,
    SortOrder: Data.SortOrder,
    // Disable: Data.Disable,
    Password: Data.Password,
  };
  //*******Assign Employee values from Database in  Yup initial value******* */
  const initialValues = {
    Code: apiData.Code,
    Name: apiData.Name,
    Job: apiData.Job,
    department: Data.DeptRecordID
      ? { RecordID: Data.DeptRecordID, Name: Data.DeptName }
      : null,
    Comm: apiData.Comm,
    Mgr: apiData.Mgr,
    Sal: apiData.Sal,
    Fax: apiData.Fax,
    SortOrder: apiData.SortOrder,
    Disable: Data.Disable === "Y" ? true : false,
    employeetype:
      Data.EmpType === "Prohibition"
        ? "PP"
        : Data.EmpType === "Permanent"
        ? "PM"
        : Data.EmpType === "Contracts In"
        ? "CI"
        : Data.EmpType === "Contracts Out"
        ? "CO"
        : // : Data.EmpType === "Contractor"
          // ? "CT"
          "",
    scrummaster: Data.ScrumMaster === "Y" ? true : false,
    prjmanager: Data.ProjectManager === "Y" ? true : false,
    joindate: Data.DateOfJoin,
    confirmdate: Data.DateOfConfirmation,
    Password: apiData.Password,
    noticeperiod: Data.NoticePeriod,
    resignationdate: Data.ResignationDate,
    resignationnote: Data.ResignationNote,
    exitinterviewby: Data.ExitInterviewBy
      ? {
        RecordID: Data?.ExitInterviewBy || 0,
        Code: Data?.ExitInterviewByCode || "",
        Name: Data?.ExitInterviewByName || "",
      }
      : null,
    exitinterviewdate: Data.ExitInterviewDate,
    exitinterviewcomments: Data.ExitInterviewComments,
    acceptedrelievingdate: Data.AcceptedRelievingDate,
    actualrelievingdate: Data.ActualRelievingDate,
   dateofsettlement: Data.DateOfSettlement,
    exitformalitiesacceptrd: Data.ExitFormalitiesAccepted === "Y" ? true : false,
  };
  console.log(apiData, "hiiii----");
  const [openPopup, setOpenPopup] = useState(false);
  const [isPopupData, setisPopupdata] = React.useState(false);
  const [opendesignPopup, setOpendesignPopup] = useState(false);
  const [openFunPopup, setOpenFunPopup] = useState(false);
  const [openDesPopup, setOpenDesPopup] = useState(false);
  // ************Lookup Function***************
  function handleShow(type) {
    if (type == "DE") {
      setOpenDEPopup(true);
    }
    if (type == "LOCATION") {
      setOpenLOCATIONPopup(true);
    }
    if (type == "GATE") {
      setOpenGATEPopup(true);
    }

    if (type == "PRO") {
      setOpenPROPopup(true);
    }
    if (type == "DESIGN") {
      setOpendesignPopup(true);
    }
    if (type == "FUN") {
      setOpenFunPopup(true);
    }
    if (type == "DISG") {
      setOpenDesPopup(true);
    }
  }

  const [selectLookupData, setselectLookupData] = React.useState({
    lookupRecordid: "",
    lookupCode: "",
    lookupDesc: "",
  });
  const [designLookup, setdesignLookup] = React.useState({
    designlookupRecordid: "",
    designlookupCode: "",
    designlookupDesc: "",
  });
  const [selectproLookupData, setselectproLookupData] = React.useState({
    PROlookupRecordid: "",
    PROlookupCode: "",
    PROlookupDesc: "",
  });

  // ***************  EMPLOYEE-FUNCTION LOOKUP  *************** //

  const [functionLookup, SetFunctionLookup] = useState(null);
  //   {
  //   funRecordID: "",
  //   funCode: "",
  //   funName: "",
  // });

  const [designationLookup, SetDesignationLookup] = useState({
    desRecordID: "",
    desCode: "",
    desName: "",
  });

  const [locationLookup, SetLocationLookup] = useState({
    locationRecordID: "",
    locationCode: "",
    locationName: "",
  });
  const [gateLookup, SetGateLookup] = useState({
    gateRecordID: "",
    gateCode: "",
    gateName: "",
  });
  if (isPopupData == false) {
    selectLookupData.lookupRecordid = Data.DeptRecordID;
    selectLookupData.lookupCode = Data.DeptCode;
    selectLookupData.lookupDesc = Data.DeptName;

    //Designation
    designLookup.designlookupRecordid = deploymentData.DesignationID;
    designLookup.designlookupCode = deploymentData.DesignationCode;
    designLookup.designlookupDesc = deploymentData.DesignationName;
    //Location
    locationLookup.locationRecordID = deploymentData.LocationID;
    locationLookup.locationCode = deploymentData.LocationCode;
    locationLookup.locationName = deploymentData.LocationName;

    //Gate
    gateLookup.gateRecordID = deploymentData.StoregatemasterID;
    gateLookup.gateCode = deploymentData.StoregatemasterCode;
    gateLookup.gateName = deploymentData.StoregatemasterName;
  }

  //************************** Lookup value assign type based Function *****************/
  const childToParent = (childdata, type) => {
    console.log("Data---" + JSON.stringify(childdata));
    setisPopupdata(true);
    if (type == "Department") {
      setselectLookupData({
        lookupCode: childdata.Code,
        lookupRecordid: childdata.RecordID,
        lookupDesc: childdata.Name,
      });
      setOpenDEPopup(false);
    }

    if (type == "Process") {
      setselectproLookupData({
        PROlookupCode: childdata.Code,
        PROlookupRecordid: childdata.RecordID,
        PROlookupDesc: childdata.Name,
      });
      setOpenPROPopup(false);
    }
    if (type == "Designation") {
      setdesignLookup({
        designlookupRecordid: childdata.RecordID,
        designlookupCode: childdata.Code,
        designlookupDesc: childdata.Name,
      });
      setOpendesignPopup(false);
    }
    if (type == "Location") {
      SetLocationLookup({
        locationRecordID: childdata.RecordID,
        // locationRecordid: childdata.RecordID,
        locationCode: childdata.Code,
        locationName: childdata.Name,
      });
      setOpenLOCATIONPopup(false);
    }
    if (type == "Gate") {
      SetGateLookup({
        gateRecordID: childdata.RecordID,
        gateCode: childdata.Code,
        gateName: childdata.Name,
      });
      setOpenGATEPopup(false);
    }
    if (type == "Functions") {
      // SetFunctionLookup({
      //   funRecordID: childdata.RecordID,
      //   funCode: childdata.Code,
      //   funName: childdata.Name,
      // });
      setOpenFunPopup(false);
    }
    if (type == "Designations") {
      // SetDesignationLookup({
      //   desRecordID: childdata.RecordID,
      //   desCode: childdata.Code,
      //   desName: childdata.Name,
      // });
      setOpenDesPopup(false);
    }
  };
  // **********Save Function*****************
  const fnSave = async (values) => {
    setLoading(true);
    setIni(false);
    if (values.Code == "") {
      toast.error("Please Enter Code");
      return;
    }
    if (values.Name == "") {
      toast.error("Please Enter Description");
      return;
    }
    var isCheck = "N";
    if (values.checkbox == true) {
      isCheck = "Y";
    }

    var saveData = {
      RecordID: recID,
      DeptRecordID: values.department.RecordID || 0,
      DeptName: values.department.Name,
      Code: values.Code,
      Name: values.Name,
      SortOrder: values.SortOrder,
      Disable: values.checkbox === true ? "Y" : "N",
      ScrumMaster: values.scrummaster === true ? "Y" : "N",
      ProjectManager: values.prjmanager === true ? "Y" : "N",
      DateOfJoin: values.joindate,
      DateOfConfirmation: values.confirmdate,
      EmpType: values.employeetype,
      Job: values.Job,
      Mgr: values.Mgr,
      Sal: values.Sal,
      Comm: values.Comm,
      Password: values.Password,
      DesignID: 0,
      LocationRecID: 0,
      GateRecID: 0,
      WeekOff: 0,
    };
    console.log(values.department.RecordID, "iiiiii----");
    var type = "";

    if (mode == "A") {
      type = "insert";
    } else {
      type = "update";
    }

    const response = await dispatch(
      postData({ accessID, action: type, idata: saveData })
    );
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);

      setLoading(false);
      navigate("/Apps/TR027/my-profile");
    } else {
      toast.error(response.payload.Msg);
      setLoading(false);
    }
  };

  /**************************************Employee Process***************** */

  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData
  );
  const explorelistViewcolumn = useSelector(
    (state) => state.exploreApi.explorecolumnData
  );
  const exploreLoading = useSelector((state) => state.exploreApi.loading);

  const [show, setScreen] = React.useState("0");
  // material
  const [supprodata, setSupprodata] = useState({
    RecordID: "",
    Comments: "",
    SortOrder: "",
    Status: "",
    skills:""
  });
  //const [funcdata, setFuncdata] = useState({
  //});
  const [boMode, setBomode] = useState("A");

  // **********ScreenChange Function*********
  const screenChange = (event) => {
    setScreen(event.target.value);

    if (event.target.value == "1") {
      dispatch(fetchExplorelitview("TR038", "Employee Process", recID, ""));
      dispatch(fetchApidata(accessID, "get", recID));
      selectcelldata("", "A", "");


    }

    if (event.target.value == "0") {
      dispatch(fetchApidata(accessID, "get", recID));
      dispatch(getResignation({ EmployeeID: recID }));

    }
    if (event.target.value == "2") {
      dispatch(
        fetchExplorelitview("TR125", "Function", `EmployeeID=${recID}`, "")
      );
      selectCellRowData({ rowData: {}, mode: "A", field: "" });
    }
    if (event.target.value == "3") {
      dispatch(
        fetchExplorelitview("TR126", "Manager", `parentID='${recID}' AND CompanyID='${compID}'`, "")
      );
      selectCellRowData({ rowData: {}, mode: "A", field: "" });
    }
    if (event.target.value == "4" || event.target.value == "9") {
      dispatch(getDeployment({ HeaderID: recID }));
      // selectCellRowData({ rowData: {}, mode: "A", field: "" });
    }
      if (event.target.value == "10") {
      dispatch(getResignation({ EmployeeID: recID }));
    }
    if (event.target.value == "5") {
      dispatch(invoiceExploreGetData({ accessID: "TR142", get: "get", recID }));
    }
    if (event.target.value == "6") {
      dispatch(
        fetchExplorelitview("TR210", "Attachment", `EmployeeID=${recID}`, "")
      );
      selectCellRowData({ rowData: {}, mode: "A", field: "" });
    }
    if (event.target.value == "7") {
      dispatch(
        fetchExplorelitview("TR212", "itemcustody", `EmployeeID=${recID}`, "")
      );
      selectCellRowData({ rowData: {}, mode: "A", field: "" });
    }
    if (event.target.value == "8") {
      dispatch(
        fetchExplorelitview(
          "TR249",
          "Leave Configuration",
          `EmployeeID='${recID}'`,
          ""
        )
      );
      selectCellRowData({ rowData: {}, mode: "A", field: "" });
    }
  };

  /******************Employee values assign a state variale******************** */
  const selectcelldata = (data, bMode, field) => {
    console.log("selectdata" + JSON.stringify(data));

    setBomode(bMode);
    setIniProcess(true);
    if (bMode == "A") {
      setSupprodata({
        RecordID: "",
        Comments: "",
        SortOrder: "",
        skills:""
      });
      setselectproLookupData({
        PROlookupRecordid: "",
        PROlookupCode: "",
        PROlookupDesc: "",
      });
    } else {
      if (field == "action") {
        console.log("selectdata" + data.Disable);
        setSupprodata({
          RecordID: data.RecordID,
          Comments: data.Comments,
          SortOrder: data.SortOrder,
          // process: data.PsRecordID
          //   ? { RecordID: data.PsRecordID, Name: data.ProcessDescription }
          //   : null,
          skills: data.Skills,
        });
        // setFuncdata({
        //   function:,
        // })
        setselectproLookupData({
          PROlookupRecordid: data.PsRecordID,
          PROlookupCode: data.ProcessCode,
          PROlookupDesc: data.ProcessDescription,
        });
      }
    }
  };
  //*******Assign Employee values from Grid table in  Yup initial value******* */
  const supprocessInitialvalues = {
    Comments: supprodata.Comments,
    SortOrder: supprodata.SortOrder,
    skills: supprodata.skills,
  };

  /******************************save  Function********** */
  const fnProcess = async (values, resetForm, types) => {
    setIniProcess(false);
    if (types == "harddelete") {
      if (supprodata.RecordID == "") {
        toast.error("Please select Process");
        return;
      }
    }
    // if (selectproLookupData.PROlookupCode == "") {
    //   toast.error("Please Choose Process Lookup");
    //   return;
    // }

    if (values.Comments == "") {
      toast.error("Please Enter Comments");
      return;
    }

    console.log(values);

    var saveData = "";
    var type = "";

    if (types === "harddelete") {
      type = "harddelete";
      saveData = {
        RecordID: supprodata.RecordID,
        EmpRecordID: recID,
        //PsRecordID: selectproLookupData.PROlookupRecordid,
        Comments: values.Comments,
        SortOrder: values.SortOrder,
        // PsRecordID: values.process.RecordID || 0,
        skills: values.skills
      };
    } else {
      setLoading(true);
      if (boMode == "A") {
        saveData = {
          RecordID: "",
          EmpRecordID: recID,
          //PsRecordID: selectproLookupData.PROlookupRecordid,
          Comments: values.Comments,
          SortOrder: values.SortOrder,
          // PsRecordID: values.process.RecordID || 0,
          skills: values.skills
        };
        type = "insert";
      } else {
        saveData = {
          RecordID: supprodata.RecordID,
          EmpRecordID: recID,
          //PsRecordID: selectproLookupData.PROlookupRecordid,
          Comments: values.Comments,
          SortOrder: values.SortOrder,
          // PsRecordID: values.process.RecordID || 0,
          skills: values.skills
        };
        type = "update";
      }
    }
    console.log("save" + JSON.stringify(saveData));

    const data = await dispatch(postApidata("TR038", type, saveData));
    if (data.payload.Status == "Y") {
      toast.success(data.payload.Msg);
      setLoading(false);
      dispatch(fetchExplorelitview("TR038", "Employee Process", recID, ""));
      resetForm();

      setSupprodata({ RecordID: "", Comments: "", SortOrder: "" });
      selectcelldata("", "A", "");
    } else {
      toast.error(data.payload.Msg);
      setLoading(false);
    }
  };
  //*********************Contact******************/
  const contactInitialvalues = {
    Code: Data.Code,
    Name: Data.Name,
    phonenumber: DataExplore.PhoneNumber,
    email: DataExplore.Email,
    aadharcardnumber: DataExplore.AadharCardNo,
    pfnumber: DataExplore.PfNo,
    esinumber: DataExplore.EsiNo,
    permanentaddress: DataExplore.PermanentAddress,
    localaddress: DataExplore.LocalAddress,
  };
  const fncontact = async (values, types) => {
    console.log(values);

    var saveData = "";
    var type = "";

    setLoading(true);

    saveData = {
      RecordID: DataExplore.RecordID,
      EmpRecordID: recID,
      PhoneNumber: values.phonenumber,
      Email: values.email,
      AadharCardNo: values.aadharcardnumber,
      PfNo: values.pfnumber,
      EsiNo: values.esinumber,
      PermanentAddress: values.permanentaddress,
      LocalAddress: values.localaddress,
    };
    type = "update";

    console.log("save" + JSON.stringify(saveData));

    const data = await dispatch(postApidata("TR142", type, saveData));
    if (data.payload.Status == "Y") {
      toast.success(data.payload.Msg);
      setLoading(false);
      // dispatch(fetchExplorelitview("TR038", "Employee Process", recID, ""));
      // resetForm();

      // setSupprodata({ RecordID: "", Comments: "", SortOrder: "" });
      // selectcelldata("", "A", "");
    } else {
      toast.error(data.payload.Msg);
      setLoading(false);
    }
  };
  const style = {
    height: "55px",
    border: "2px solid #1769aa ",
    borderRadius: "5px",
    backgroundColor: "#EDEDED",
  };

  const clrForm = () => {
    setSupprodata({ RecordID: "", Comments: "", SortOrder: "" });
    setselectproLookupData({
      PROlookupRecordid: "",
      PROlookupCode: "",
      PROlookupDesc: "",
    });

    selectcelldata("", "A", "");
  };

  let VISIBLE_FIELDS;
  if (show == "7") {
    VISIBLE_FIELDS = ["slno", "Item", "ItemValue", "action"];
  } else if (show == "6") {
    VISIBLE_FIELDS = ["slno", "Description", "action"];
  } else if (show == "1") {
    VISIBLE_FIELDS = ["slno", "Skills", "Comments", "action"];
  } else if (show == "2") {
    VISIBLE_FIELDS = ["slno", "Functions", "action"];
  } else if (show == "8") {
    VISIBLE_FIELDS = [
      "slno",
      "LeavePart",
      "AvailDays",
      "EligibleDays",
      "action",
    ];
  } else {
    VISIBLE_FIELDS = ["slno", "DesignationCode", "DesignationName", "action"];
  }

  // const columns = React.useMemo(
  //   () =>
  //     explorelistViewcolumn.filter((column) =>

  //       VISIBLE_FIELDS.includes(column.field)
  //     ),
  //   [explorelistViewcolumn]
  // );
  const columns = React.useMemo(() => {
    let visibleColumns = explorelistViewcolumn.filter((column) =>
      VISIBLE_FIELDS.includes(column.field)
    );

    if (VISIBLE_FIELDS.includes("slno")) {
      const slnoColumn = {
        field: "slno",
        headerName: "SL#",
        width: 50,
        sortable: false,
        filterable: false,
        valueGetter: (params) =>
          `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
      };

      visibleColumns = [slnoColumn, ...visibleColumns];
    }

    return visibleColumns;
  }, [explorelistViewcolumn, VISIBLE_FIELDS]);

  // const handleTypeChange = (e, recordID) => {
  //   const { value } = e.target;
  //   setRows(prevRows =>
  //     prevRows.map(row =>
  //       row.RecordID === recordID ? { ...row, ManualType: value } : row
  //     )
  //   );
  // };
  const handleSelectionCustomerChange = (newValue) => {
    if (newValue) {
      // setSelectedFunctionOptions(newValue);
      // setSelectedfunctionid(newValue.RecordID);
      // setSelectedfunctionName(newValue.Name);
      // manager screen
      setSelectedManagerOptions(newValue);
      setSelectedManagerid(newValue.RecordID);
      setSelectedManagerName(newValue.Name);
      console.log(newValue.Name, "--selectedproductid");
    } else {
      // setSelectedFunctionOptions(null);
      // setSelectedfunctionid(null);
      // setSelectedfunctionName(null);
      // manager screen
      setSelectedManagerOptions(null);
      setSelectedManagerid(null);
      setSelectedManagerName(null);
    }
  };

  const column = [
    {
      headerName: "SL#",
      field: "SLNO",
      width: "100",
      align: "left",
      headerAlign: "center",
      hide: false,
      maxWidth: 50,
    },
    // {
    //   headerName: 'DesignationCode',
    //   field: 'DesignationCode',
    //   width: '100',
    //   align: 'left',
    //   headerAlign: 'center',
    //   hide: true
    // },
    // {
    //   headerName: 'Designation Name',
    //   field: 'DesignationName',
    //   width: '100',
    //   align: 'left',
    //   headerAlign: 'center',
    //   hide: true
    // },
    {
      headerName: (
        <span>
          Designation Name <span style={{ color: "red" }}>*</span>
        </span>
      ),
      field: "DesignationName",
      width: 400,
      headerAlign: "center",
      hide: false,
      editable: true,
      sortable: false,
      renderEditCell: (params) => {
        // setSelectedCustomerOptions(params.row.Name);
        const isInEditMode =
          rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return (
            <Productautocomplete
              name="manager"
              label="Designation"
              id="manager"
              value={selectedCustomerOptions}
              onChange={handleSelectionCustomerChange}
              defaultValue={params.row.ManualItem}
              url={`${listViewurl}?data={"Query":{"AccessID":"2047","ScreenName":"Designation","Filter":"parentID=${compID}","Any":""}}`}
            />
          );
        }
        return null; // Return null or a default value when not in edit mode
      },
      renderCell: (params) => {
        // Assuming ManualItem is an object that has a 'Name' property
        const manualItem = params.value;
        return manualItem ? manualItem.Name : ""; // Display Name from the ManualItem object, or empty string if not available
      },
    },
{
  headerName: "Manager",
  field: "EmployeeName",
  width: 300,
  align: "left",
  headerAlign: "center",
},
    
    //  {
    //   headerName: "DesignationName",
    //   field: "DesignationName",
    //   width: 800,
    //   align: "left",
    //   headerAlign: "center",
    //   hide: false,
    //   editable: true,
    //   sortable: false,
    //     renderEditCell: (params) => {
    //       const isInEditMode = rowModesModel[params.id]?.mode === GridRowModes.Edit;

    //       if (isInEditMode) {
    //         return (
    //           <Productautocomplete
    //             name="DesignationName"
    //             label="Manager"
    //             id="DesignationName"
    //             value={selectedManagerOptions}
    //             onChange={handleSelectionCustomerChange}
    //             defaultValue={params.row.DesignationName}
    //             url={`http://cafemgr.benmoredata.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2047","ScreenName":"Designations","Filter":"","Any":""}}`}
    //           />
    //         );
    //       }
    //       return null;  // Return null or a default value when not in edit mode
    //     },
    //     renderCell: (params) => {
    //       // Assuming ManualItem is an object that has a 'Name' property
    //       const DesignationName = params.value;
    //       return DesignationName ? DesignationName.Name : '';  // Display Name from the ManualItem object, or empty string if not available
    //  }},

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 200,
      cellClassName: "actions",
      getActions: (params) => {
        const isInEditMode =
          rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{ color: "#009688" }}
              // onClick={handleSave(params.id, params, funMode)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              // onClick={() => {
              //   setRowModesModel((prev) => ({
              //     ...prev,
              //     [params.id]: { mode: GridRowModes.View },
              //   }));
              //   setSelectedCustomerOptions(null);
              // }}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<AddIcon style={{ color: "#00563B" }} />}
            label="Add"
            // onClick={() => managerhandleInsert(params.id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<EditIcon style={{ color: "#3498db" }} />}
            label="Edit"
            // onClick={handleEditClick(params.id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon style={{ color: "#e74c3c" }} />}
            label="Delete"
            // onClick={handleManagerDeleteClick(params.id, params, "harddelete")}
            color="inherit"
          />,
        ];
      },
    },
  ];

  // **********Grid header function************
  const [rowCount, setRowCount] = useState(0);
  function Custombar() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>List of Skills</Typography>
          <Typography variant="h5">{`(${rowCount})`}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
          {/* <Tooltip title="ADD">
            <IconButton onClick={() => selectcelldata("", "A", "")}>
              <AddOutlinedIcon />
            </IconButton>
          </Tooltip> */}
        </Box>
      </GridToolbarContainer>
    );
  }
  function EditmanagerToolbar({ setRows, setRowModesModel }) {
    return (
      <GridToolbarContainer
        sx={{
          marginBottom: "10px",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <Button
        disabled
          color="primary"
          startIcon={<AddIcon />}
          onClick={managerhandleInsert}
        >
          Add Record
        </Button>
      </GridToolbarContainer>
    );
  }

  // *************** EMPLOYEE-FUNCTION SCREEN SAVE FUNCTION *************** //

  function Employee() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          {/* <Typography>
            {show == "2" ? "List of Functions" : "List of Designation"}||{show=="6" && "List of Documents"}
            
          </Typography> */}
          <Typography>
            {{
              2: "List of Functions",
              3: "List of Managers",
              6: "List of Documents",
              7: "List of Items",
              8: "List of Configurations",
            }[show] || "List of Designation"}
          </Typography>

          {/* <Typography>
          {show === "2" ? "List of Functions" : (show === "6" ? "List of Documents": show === "7" ? "ItemCustody" : "List of Designation")}
          
          </Typography> */}

          <Typography variant="h5">{`(${rowCount})`}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
          <Tooltip title="ADD">
            <IconButton type="reset">
              <AddOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </GridToolbarContainer>
    );
  }
  const [laomode, setLaoMode] = useState("A");
  const [laoEmpRecID, setLaoEmpRecID] = useState("");
  const [fdata, setFdata] = useState({});
  const functionInitialValue = {
    code: Data.Code,
    description: Data.Name,
    imageurl: Data.ImageName
      ? store.getState().globalurl.imageUrl + Data.ImageName
      : store.getState().globalurl.imageUrl + "Defaultimg.jpg",
    // function:Data.FunctionsID ? {RecordID:Data.FunctionsID,Name:Data.FunctionName}: null,
    //function: funcData.function,
  };
  const [funMode, setFunMode] = useState("A");
  const [funEmpRecID, setFunEmpRecID] = useState("");
  const [LeaveconLTData, setselectLeaveconLTData] = React.useState(null);
  const [LeaveCondata, setLeaveCondata] = useState({
    recordID: "",
    LeaveTypeID: "",
    totaldays: "",
    availableleave: "",
    elligibledays: "",
    Year: "",
  });
  const [itemCustodyData, setItemCustodyData] = useState({
    recordID: "",
    itemNO: "",
    itemName: "",
    assestID: "",
    itemValue: "",
    reference: "",
  });

  const selectCellRowData = ({ rowData, mode, field }) => {
    console.log(
      "🚀 ~ file: Editfunction.jsx:178 ~ selectcelldata ~ rowData:",
      rowData
    );

    setFunMode(mode);
    setLaoMode(mode);

    if (mode == "A") {
      setFunMgrRecID("");
      setFunEmpRecID("");
      SetFunctionLookup(null);
      //   {
      //   funRecordID: "",
      //   funCode: "",
      //   funName: "",
      // });
      setselectLeaveconLTData(null);
      setLeaveCondata({
        recordID: "",
        LeaveTypeID: "",
        totaldays: "",
        availableleave: "",
        elligibledays: "",
        Year: "",
      });
      SetDesignationLookup(null);
      //   {
      //   desRecordID: "",
      //   desCode: "",
      //   desName: "",
      // });
      SetEmpLoaData({
        description: "",
        recordID: "",
      });
      // setFdata({
      //   function: null,
      // });
      setImgName("");

      setItemCustodyData({
        recordID: "",
        itemNO: "",
        itemName: "",
        assestID: "",
        itemValue: "",
        reference: "",
      });
    } else {
      if (field == "action") {
        console.log(ImageName, "--find imagene in Selectcelldata");
        console.log(rowData.Attachment, "--rowData.Attachment");
        
        setFunMgrRecID(rowData.RecordID);
        setFunEmpRecID(rowData.RecordID);
        SetFunctionLookup({
          RecordID: rowData.FunctionsID,
          Code: rowData.FunctionCode,
          Name: rowData.FunctionName,
        });
        setselectLeaveconLTData({
          RecordID: rowData.LeaveTypeID,
          Code: "",
          Name: rowData.LeavePart,
        });
        //     setFdata({
        //       function: rowData.FunctionsID
        // ? { RecordID: rowData.FunctionsID, Name: rowData.FunctionName }
        // : null,
        // });
        SetDesignationLookup({
          RecordID: rowData.DesignationID,
          Code: rowData.DesignationCode,
          Name: rowData.DesignationName,
        });
        SetEmpLoaData({
          description: rowData.Description,
          recordID: rowData.RecordID,
        });
        setImgName(rowData.Attachment);
        setItemCustodyData({
          recordID: rowData.RecordID,
          itemNO: rowData.ItemNumber,
          itemName: rowData.ItemName,
          assestID: rowData.ItemValue,
          itemValue: rowData.ItemValue,
          reference: rowData.ItemValue,
        });
        setLeaveCondata({
          recordID: rowData.RecordID,
          totaldays: rowData.TotalDays,
          availableleave: rowData.AvailDays,
          elligibledays: rowData.EligibleDays,
          LeaveTypeID: rowData.LeaveTypeID
            ? {
                RecordID: rowData.LeaveTypeID,
                Code: "",
                Name: rowData.LeavePart,
              }
            : null,
          Year: rowData.Year,
        });
      }
    }
  };
  const empFunctionFn = async (values, resetForm, del) => {
    let action =
      funMode === "A" && !del
        ? "insert"
        : funMode === "E" && del
        ? "harddelete"
        : "update";
    const idata = {
      RecordID: funEmpRecID,
      EmployeeID: recID,
      //FunctionsID: functionLookup.funRecordID
      FunctionsID: functionLookup ? functionLookup.RecordID : "",
    };

    const response = await dispatch(
      explorePostData({ accessID: "TR125", action, idata })
    );
    if (response.payload.Status == "Y") {
      dispatch(
        fetchExplorelitview("TR125", "Function", `EmployeeID=${recID}`, "")
      );

      toast.success(response.payload.Msg);

      selectCellRowData({ rowData: {}, mode: "A", field: "" });
      resetForm();
    } else {
      toast.error(response.payload.Msg);
    }
  };

  // *************** ITEMCUSTODY SCREEN SAVE FUNCTION *************** //

  const itemcustodyInitialValue = {
    code: Data.Code,
    description: Data.Name,
    imageurl: Data.ImageName
      ? store.getState().globalurl.imageUrl + Data.ImageName
      : store.getState().globalurl.imageUrl + "Defaultimg.jpg",
    ItemNumber: itemCustodyData.itemNO,
    ItemName: itemCustodyData.itemName,
    AssestID: itemCustodyData.assestID,
    PurchaseReference: itemCustodyData.reference,
    ItemValue: itemCustodyData.itemValue,
    Disable: "N",
  };
  const empItemCustodyFn = async (values, resetForm, del) => {
    setLoading(true);
    let action =
      funMode === "A" && !del
        ? "insert"
        : funMode === "E" && del
        ? "harddelete"
        : "update";
    const idata = {
      RecordID: itemCustodyData.recordID,
      EmployeeID: recID,
      ItemNumber: values.ItemNumber,
      ItemName: values.ItemName,
      AssestID: values.AssestID,
      PurchaseReference: values.PurchaseReference,
      ItemValue: values.ItemValue,
      Disable: "N",
    };
    // console.log("save" + JSON.stringify(saveData));

    const response = await dispatch(
      explorePostData({ accessID: "TR212", action, idata })
    );
    if (response.payload.Status == "Y") {
      setLoading(false);
      dispatch(
        fetchExplorelitview("TR212", "ItemCustody", `EmployeeID=${recID}`, "")
      );

      toast.success(response.payload.Msg);

      selectCellRowData({ rowData: {}, mode: "A", field: "" });
      resetForm();
    } else {
      setLoading(false);
      toast.error(response.payload.Msg);
    }
  };

  // *************** EMPLOYEE-FUNCTION SCREEN SAVE FUNCTION *************** //

  const managerInitialValue = {
    code: Data.Code,
    description: Data.Name,
    imageurl: Data.ImageName
      ? store.getState().globalurl.imageUrl + Data.ImageName
      : store.getState().globalurl.imageUrl + "Defaultimg.jpg",
    //manager: Data.DesignationID?{RecordID: Data.DesignationID,Name:Data.DesignationName}:null
  };
  const [funMgrRecID, setFunMgrRecID] = useState("");

  const [rows, setRows] = useState([]);

  const [updatedRowData, setUpdatedRowData] = useState([]);
  const [insertedRowData, setInsertedRowData] = useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});

  const handleManagerDeleteClick = (id) => async () => {
    try {
      console.log("Deleting record with recID:", recID); // Debugging the value of recID

      // First, remove the row from the state
      setRows((prev) => prev.filter((row) => row.RecordID !== id));
      // toast.success("Row deleted successfully.");
      const idata = {
        RecordID: recID,
      };
      // Now, dispatch the API call to perform the delete action
      const response = await dispatch(
        postData({
          accessID: "TR126", // Your access ID
          action: "harddelete", // Action for deleting the record
          idata: idata, // Record ID of the deleted row
        })
      );

      // Check the response status for success
      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg); // Show success message
      } else {
        toast.error(response.payload.Msg); // Show error message if failed
      }

      // Optionally fetch updated data or reset any related state
      // dispatch(fetchExplorelitview("TR228", "Manual Sales Details", `${recID}`, ""));
    } catch (error) {
      console.error("Error deleting row:", error);
      toast.error("Error occurred during delete.");
    }
  };
  const [errorState, setErrorState] = React.useState({}); // To track errors

  //Function Screen Autocompleted Call Method
  const processRowUpdate = (newRow, oldRow) => {
    console.log("------inside processrowupdate");
    console.log(newRow, "--find newRow");

    const isNew = !oldRow?.RecordID; // Check if this is a new row
    const updatedRow = { ...newRow, isNew }; // Add `isNew` flag to row data

    // Managers Screen
    updatedRow.DesignationName = selectedManagerName;
    updatedRow.DesignationID = selectedManagerid;

    // Check if a row with the same RecordID or unique identifier exists before updating
    // if (rows.some(row => row.RecordID === updatedRow.RecordID && row.SLNO === updatedRow.SLNO)) {
    //   toast.error("This record already exists.");
    //   return oldRow; // Prevent updating the row if it's a duplicate
    // }
    //  // Ensure the row is not empty
    //   if (!updatedRow.FunctionsID || !updatedRow.FunctionName) {
    //     toast.error("Please fill the required fields.");
    //     return oldRow; // Prevent saving if any required field is empty
    //   }

    // Ensure you can see the updated row before setRows is called
    console.log(updatedRow, "--find updatedRow before setRows");

    setRows((prev) => {
      const index = prev.findIndex(
        (row) => row.RecordID === updatedRow.RecordID
      );
      if (index !== -1) {
        const newData = [...prev];
        newData[index] = updatedRow; // Update the row in the array
        return newData;
      }
      return [...prev, updatedRow]; // If not found, add a new row
    });

    const params = { row: updatedRow }; // Reassign the updated row to params
    handleSave(updatedRow.RecordID, params, funMode); // Call handleSave with updated params

    return updatedRow; // Return the updated row to reflect changes in the DataGrid
  };

  // Handle dropdown value change

  const handleEditClick = (id) => () => {
    setFunMode("E");
    // setEditingRowId(id);
    console.log("EditMode");
    setRowModesModel((prev) => ({
      ...prev,
      [id]: { mode: GridRowModes.Edit },
    }));
    // setIsDropdownVisible(true);
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    console.log("---handleRowModesModelChange calling");
    setRowModesModel(newRowModesModel);

    setSelectedManagerOptions(null);
  };

  const handleSave = (id, params, action) => () => {
    console.log("-----Step1: Local save called");

    const rowToSave = params?.row;
    if (!rowToSave) {
      toast.error("Row not found.");
      return;
    }
    const isNew = rowToSave.isNew; // Check if this is a new row
    console.log("Row to save:", rowToSave);
    setRows((prev) =>
      prev.map((row) =>
        row.RecordID === id
          ? {
              ...row,
              ...rowToSave,
              isNew: isNew && action !== "delete",
              isUpdated: !isNew,
            } // Mark as updated if not new
          : row
      )
    );

    // Update row mode to view
    setRowModesModel((prev) => ({
      ...prev,
      [id]: { mode: GridRowModes.View },
    }));

    // setIsDropdownVisible(false);
  };
  const handleMangerSave = (id, params, action) => () => {
    console.log("-----Step1: Local save called");

    const rowToSave = params?.row;
    if (!rowToSave) {
      toast.error("Row not found.");
      return;
    }
    const isNew = rowToSave.isNew; // Check if this is a new row
    console.log("Row to save:", rowToSave);
    setRows((prev) =>
      prev.map((row) =>
        row.RecordID === id
          ? {
              ...row,
              ...rowToSave,
              isNew: isNew && action !== "delete",
              isUpdated: !isNew,
            } // Mark as updated if not new
          : row
      )
    );

    // Update row mode to view
    setRowModesModel((prev) => ({
      ...prev,
      [id]: { mode: GridRowModes.View },
    }));

    // setIsDropdownVisible(false);
  };

  //     setFunMode("A");

  //     console.log("----------Step 1");

  //     const newId = Math.round(Math.random() * 10000); // Temporary unique ID
  //   // const duplicateRowExists = rows.some(row => row.RecordID === newId);
  //   // if (duplicateRowExists) {
  //   //   toast.error("A row with this RecordID already exists.");
  //   //   return;
  //   // }

  //     setRows((prevRows) => {
  //       const index = prevRows.findIndex((row) => row.RecordID === recordID); // ✅ Find the clicked row's index

  //       if (index === -1) return prevRows; // If not found, return unchanged rows

  //       const nextSLNO =
  //         prevRows.length > 0 ? Math.max(...prevRows.map((row) => row.SLNO || 0)) + 1 : 1;

  //       const newRow = {
  //         RecordID: newId, // Temporary ID, replaced after backend save
  //         SLNO: nextSLNO,
  //         EmployeeID: "",
  //         FunctionsID: "",
  //         FunctionName: "",
  //         isNew: true, // Mark as new
  //       };

  //       console.log("----step2 setRows initializing Objects");
  //       console.log("Inserted row:", newRow);

  //       const updatedRows = [...prevRows];
  //       updatedRows.splice(index + 1, 0, newRow); // ✅ Insert row at the correct position

  //       return updatedRows;
  //     });

  //     console.log("----step3 setRowModesModel initializing Objects");
  //     setRowModesModel((prev) => ({
  //       ...prev,
  //       [newId]: { mode: GridRowModes.Edit },
  //     }));
  //   };
  const managerhandleInsert = () => {
    setFunMode("A");

    console.log("----------Step 1");
    const newId = Math.round(Math.random() * 10000); // Temporary unique ID
    setRows((prevRows) => {
      const nextSLNO =
        prevRows.length > 0
          ? Math.max(...prevRows.map((row) => row.SLNO || 0)) + 1
          : 1; // Determine next SLNO

      const newRow = {
        Recordid: newId, // Temporary ID, replaced after backend save
        SLNO: nextSLNO,
        EmployeeID: "",
        DesignationName: "",
        DesignationID: "",
        isNew: true, // Mark as new
      };

      console.log("----step2 setRows initializing Objects");
      console.log("Inserted row:", newRow); // Log the new row to the console

      return [...prevRows, newRow]; // Append the new row to the existing rows
    });

    console.log("----step3 setRowModesModel initializing Objects");
    setRowModesModel((prev) => ({
      ...prev,
      [newId]: { mode: GridRowModes.Edit },
    }));
  };
  const handleSaveButtonMangersClick = async (action) => {
    console.log("---Saving rows:", rows);
    console.log(funMode, "--finding action");
    // Dynamically determine the action based on the passed action type
    const saveAction =
      funMode === "A" ? "insert" : funMode === "E" ? "update" : "defaultAction";
    console.log("Action to perform:", saveAction);

    // Prepare the data structure to send in the API request
    const idata = rows.map((row) => ({
      RecordID: row.RecordID || "", // Empty for new rows, if any
      EmployeeID: recID,
      DesignationID: row.DesignationID || "",
    }));
    console.log("-----Formatted idata :", idata);

    console.log(selectedManagerid, "-------selectedManagerid");
    console.log("-----Formatted idata for action:", saveAction, idata);

    try {
      // Dispatch the API call with the dynamic action (insert, update, delete)
      const response = await dispatch(
        postData({
          accessID: "TR126",
          action: saveAction, // Use the dynamically determined action
          idata: idata,
        })
      );

      // Check response status for success
      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);

        // Optionally reset isNew and isUpdated for all rows if save was successful
        setRows((prev) =>
          prev.map((row) => ({
            ...row,
            isNew: false,
            isUpdated: false,
          }))
        );

        // Fetch updated data based on ManualSalesID
        dispatch(
          fetchExplorelitview("TR126", "Manager", `parentID=${recID}`, "")
        );
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      console.error("Error saving rows:", error);
      toast.error("Error occurred during save.");
    }
  };

  const mgrFunctionFn = async (values, resetForm, del) => {
    let action =
      funMode === "A" && !del
        ? "insert"
        : funMode === "E" && del
        ? "harddelete"
        : "update";
    const idata = {
      RecordID: funMgrRecID,
      EmployeeID: recID,
      DesignationID: designationLookup.RecordID,
      //DesignationID: values.manager.RecordID || 0,
    };
    // console.log("save" + JSON.stringify(saveData));

    const response = await dispatch(
      explorePostData({ accessID: "TR126", action, idata })
    );
    if (response.payload.Status == "Y") {
      dispatch(
        fetchExplorelitview("TR126", "Manager", `parentID=${recID}`, "")
      );

      toast.success(response.payload.Msg);

      selectCellRowData({ rowData: {}, mode: "A", field: "" });
      resetForm();
    } else {
      toast.error(response.payload.Msg);
    }
  };
  //Leave Configuration-------------------------------
  const LCInitialValue = {
    Code: Data.Code,
    Name: Data.Name,
    LeaveTypeID: LeaveCondata.LeaveTypeID,
    LeavePart: "N",
    totaldays: LeaveCondata.totaldays,
    availableleave: LeaveCondata.availableleave,
    elligibledays: LeaveCondata.elligibledays,
    Year:
      LeaveCondata.Year === "2024"
        ? "2024"
        : LeaveCondata.Year === "2025"
        ? "2025"
        : LeaveCondata.Year === "2026"
        ? "2026"
        : "",
  };
  // const [funMgrRecID, setFunMgrRecID] = useState("");
  const currentYear = new Date().getFullYear();

  console.log(currentYear, "currentYear");

  const LCsaveFn = async (values, resetForm, del) => {
    console.log("--calling LCsave");
    setLoading(true);
    let action =
      funMode === "A" && !del
        ? "insert"
        : funMode === "E" && del
        ? "harddelete"
        : "update";
    const idata = {
      RecordID: LeaveCondata.recordID,
      compID,
      // Year: currentYear,
      Year: values.Year,
      EmployeeID: recID,
      LeaveTypeID: LeaveconLTData ? LeaveconLTData.RecordID : 0,
      LeaveTypeName: LeaveconLTData ? LeaveconLTData.Name : "",
      TotalDays: Number(values.totaldays),
      AvailDays: Number(values.availableleave),
      EligibleDays: Number(values.totaldays) - Number(values.availableleave),
      LeavePart: "N",
    };
    // console.log("save" + JSON.stringify(LCsaveFn));
    console.log(idata, "--idat LCsaveFna");
    // const response = await dispatch(
    //   explorePostData({ accessID: "TR249", action, idata })
    // );
    // if (response.payload.Status == "Y") {
    //     //  setLoading(false);
    //   dispatch(fetchExplorelitview("TR249", "Leave Configuration", `EmployeeID='${recID}'`, "")
    //   );

    //   toast.success(response.payload.Msg);

    //   selectCellRowData({ rowData: {}, mode: "A", field: "" });
    //   resetForm();
    // } else {
    //   toast.error(response.payload.Msg);
    // }
    const response = await dispatch(
      explorePostData({ accessID: "TR249", action, idata })
    );
    if (response.payload.Status == "Y") {
      setLoading(false);
      await dispatch(
        fetchExplorelitview(
          "TR249",
          "Leave Configuration",
          `EmployeeID='${recID}'`,
          ""
        )
      );

      toast.success(response.payload.Msg);

      selectCellRowData({ rowData: {}, mode: "A", field: "" });
    } else {
      toast.error(response.payload.Msg);
    }
  };
  const deploymentInitialValue = {
    code: Data.Code,
    description: Data.Name,
    // checkin: deploymentData.CheckInTime,
    // checkout: deploymentData.CheckOutTime,
    Monday: deploymentData.MondayShift === "Y" ? true : false,
    Tuesday: deploymentData.TuesdayShift === "Y" ? true : false,
    Wednesday: deploymentData.WednesdayShift === "Y" ? true : false,
    Thursday: deploymentData.ThursdayShift === "Y" ? true : false,
    Friday: deploymentData.FridayShift === "Y" ? true : false,
    Saturday: deploymentData.SaturdayShift === "Y" ? true : false,
    Sunday: deploymentData.SundayShift === "Y" ? true : false,
    imageurl: Data.ImageName
      ? store.getState().globalurl.imageUrl + Data.ImageName
      : store.getState().globalurl.imageUrl + "Defaultimg.jpg",
    manager: deploymentData.DesignationID
      ? {
          RecordID: deploymentData.DesignationID,
          Name: deploymentData.DesignationName,
        }
      : { RecordID: 0, Name: "" },
    location: deploymentData.LocationID
      ? {
          RecordID: deploymentData.LocationID,
          Name: deploymentData.LocationName,
        }
      : { RecordID: 0, Name: "" },
    gate: deploymentData.StoregatemasterID
      ? {
          RecordID: deploymentData.StoregatemasterID,
          Code: deploymentData.StoregatemasterCode,
          Name: deploymentData.StoregatemasterName,
        }
      : null,
    project: deploymentData.DefaultProject
      ? {
          RecordID: deploymentData.DefaultProject,
          Code: deploymentData.ProjectCode,
          Name: deploymentData.ProjectName,
        }
      : null,
    function: deploymentData.DefaultFunction
      ? {
          RecordID: deploymentData.DefaultFunction,
          Code: deploymentData.FunctionCode,
          Name: deploymentData.FunctionName,
        }
      : null,
    shift: deploymentData.ShiftID
      ? {
          RecordID: deploymentData.ShiftID,
          Code: deploymentData.ShiftCode,
          Name: deploymentData.ShiftName,
        }
      : null,
    checkin: deploymentData.ShiftStartTime || "",
    checkout: deploymentData.ShiftEndTime || "",
    biometric: deploymentData.BioMetric === "Y" ? true : false,
    mobile: deploymentData.MobileGeoFencing === "Y" ? true : false,
    managermanual: deploymentData.ManagerManual === "Y" ? true : false,
    cloud: deploymentData.CloudApplication === "Y" ? true : false,
    Horizontal: true,
    Vertical: deploymentData.Vertical === "Y" ? true : false,
    HorizontalMimNo: deploymentData.HorizontalMimNo || 1,
    VerticalMimNo: deploymentData.VerticalMimNo || 3,
    AutoApprovalYesOrNo:
      deploymentData.AutoApprovalYesOrNo === "Y" ? true : false,
    ApprovelTolerance: deploymentData.ApprovelTolerance,
    AutoRejectionYesOrNo:
      deploymentData.AutoRejectionYesOrNo === "Y" ? true : false,
    RejectionTolerance: deploymentData.RejectionTolerance,
  };
  // console.log(deploymentInitialValue);
  const Fndeployment = async (values, resetForm, del) => {
    const idata = {
      HeaderID: recID,
      // CheckInTime: values.checkin,
      // CheckOutTime: values.checkout,
      CheckInTime: values.shift?.ShiftStartTime || "",
      CheckOutTime: values.shift?.ShiftendTime || "",
      Monday: values.Monday === true ? "Y" : "N",
      Tuesday: values.Tuesday === true ? "Y" : "N",
      Wednesday: values.Wednesday === true ? "Y" : "N",
      Thursday: values.Thursday === true ? "Y" : "N",
      Friday: values.Friday === true ? "Y" : "N",
      Saturday: values.Saturday === true ? "Y" : "N",
      Sunday: values.Sunday === true ? "Y" : "N",
      //DesignationID: designLookup.designlookupRecordid,
      //LocationID: locationLookup.locationRecordID,
      //StoregatemasterID: gateLookup.gateRecordID,
      DesignationID: values.manager.RecordID || 0,
      LocationID: values.location.RecordID || 0,
      StoregatemasterID: values.gate.RecordID || 0,
      DefaultProject: values.project.RecordID || 0,
      ProjectCode: values.project.Code || "",
      ProjectName: values.project.Name || "",
      DefaultFunction: values.function.RecordID || 0,
      FunctionCode: values.function.Code || "",
      FunctionName: values.function.Name || "",
      ShiftID: values.shift.RecordID || 0,
      ShiftCode: values.shift.Code || "",
      ShiftName: values.shift.Name || "",
      BioMetric: values.biometric === true ? "Y" : "N",
      ManagerManual: values.managermanual === true ? "Y" : "N",
      CloudApplication: values.cloud === true ? "Y" : "N",
      MobileGeoFencing: values.mobile === true ? "Y" : "N",
    };

    const response = await dispatch(postDeployment({ data: idata }));
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
    } else {
      toast.error(response.payload.Msg);
    }
  };



  //RESIGNATION_SECTION
  
    const resignationinitialvalues = {
    code: Data.Code,
    description: Data.Name,
    resignationdate: ResignationGetData.ResignationDate,
    resignationnote: ResignationGetData.ResignationNote,
    exitinterviewby: ResignationGetData.ExitInterviewBy
      ? {
        RecordID: ResignationGetData.ExitInterviewBy,
        Code: ResignationGetData.ExitInterviewByCode,
        Name: ResignationGetData.ExitInterviewByName,
      }
      : null,
    exitinterviewdate: ResignationGetData.ExitInterviewDate,
    exitinterviewcomments: ResignationGetData.ExitInterviewComments,
    acceptedrelievingdate: ResignationGetData.AcceptedRelievingDate,
    actualrelievingdate: ResignationGetData.ActualRelievingDate,
   dateofsettlement: ResignationGetData.DateOfSettlement,
    exitformalitiesacceptrd: ResignationGetData.ExitFormalitiesAccepted === "Y" ? true : false,
   
  };

  //RESIGNATION_POST
   const Fnsaveresignation = async (values, resetForm, del) => {
    console.log(values, "--values");

    const idata = {
      EmployeeID: recID,
      ResignationDate: values.resignationdate,
      ResignationNote: values.resignationnote,
      ExitInterviewBy: values.exitinterviewby?.RecordID || 0,
      ExitInterviewDate: values.exitinterviewdate,
      ExitInterviewComments: values.exitinterviewcomments,
      AcceptedRelievingDate: values.acceptedrelievingdate,
      ActualRelievingDate: values.actualrelievingdate,
      DateOfSettlement: values.dateofsettlement,
      ExitFormalitiesAccepted: values.exitformalitiesacceptrd === true ? "Y" : "N",
          
    };

   console.log(idata, "--resignation idata");
// return;
    const response = await dispatch(ResignationPOST({ data: idata }));
    // return;
    if (response.payload.Status == "Y") {
      dispatch(getResignation({ EmployeeID: recID }));
      toast.success(response.payload.Msg);
    } else {
      toast.error(response.payload.Msg);
    }
  };

  const FndeploymentApprovals = async (values, resetForm, del) => {
    console.log(values, "--values");

    const idata = {
      HeaderID: recID,
      CheckInTime: deploymentData.ShiftStartTime || "",
      CheckOutTime: deploymentData.ShiftEndTime || "",
      // CheckInTime: values.checkin || "",
      // CheckOutTime: values.checkout || "",
      Monday: deploymentData.MondayShift === "Y" ? true : false,
      Tuesday: deploymentData.TuesdayShift === "Y" ? true : false,
      Wednesday: deploymentData.WednesdayShift === "Y" ? true : false,
      Thursday: deploymentData.ThursdayShift === "Y" ? true : false,
      Friday: deploymentData.FridayShift === "Y" ? true : false,
      Saturday: deploymentData.SaturdayShift === "Y" ? true : false,
      Sunday: deploymentData.SundayShift === "Y" ? true : false,
      // Monday: values.monday === true ? "Y" : "N",
      // Tuesday: values.tuesday === true ? "Y" : "N",
      // Wednesday: values.wednesday === true ? "Y" : "N",
      // Thursday: values.thursday === true ? "Y" : "N",
      // Friday: values.friday === true ? "Y" : "N",
      // Saturday: values.saturday === true ? "Y" : "N",
      // Sunday: values.sunday === true ? "Y" : "N",
      DesignationID: deploymentData.DesignationID || 0,
      LocationID: deploymentData.LocationID || 0,
      StoregatemasterID: deploymentData.StoregatemasterID || 0,
      DefaultProject: deploymentData.DefaultProject || 0,
      ProjectCode: deploymentData.ProjectCode || "",
      ProjectName: deploymentData.ProjectName || "",
      DefaultFunction: deploymentData.DefaultFunction,
      FunctionCode: deploymentData.FunctionCode || "",
      FunctionName: deploymentData.FunctionName || "",
      ShiftID: deploymentData.ShiftID || 0,
      ShiftCode: deploymentData.ShiftCode || "",
      ShiftName: deploymentData.ShiftName || "",

      // Horizontal: values.horizontal === true ? "Y" : "N",
      // Vertical: values.vertical === true ? "Y" : "N",
      // HorizontalMimNo: values.Horizontalmin || 0,
      // VerticalMimNo: values.Verticalmin || 0,
      // DesignationID: designLookup ? designLookup.RecordID : 0,
      // LocationID: locationLookup ? locationLookup.RecordID : 0,
      // StoregatemasterID: gateLookup ? gateLookup.RecordID : 0,
      compID,
      Horizontal: values.Horizontal === true ? "Y" : "N",
      Vertical: values.Vertical === true ? "Y" : "N",
      HorizontalMimNo: values.HorizontalMimNo,
      VerticalMimNo: values.VerticalMimNo,
      AutoApprovalYesOrNo: values.AutoApprovalYesOrNo === true ? "Y" : "N",
      ApprovelTolerance: values.ApprovelTolerance,
      AutoRejectionYesOrNo: values.AutoRejectionYesOrNo === true ? "Y" : "N",
      RejectionTolerance: values.RejectionTolerance,
    };

    // console.log(locationLookup.locationRecordID, "????????");
    const response = await dispatch(postDeployment({ data: idata }));
    // return;
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
    } else {
      toast.error(response.payload.Msg);
    }
  };
  /*************LOA************* */
  const [empLoaData, SetEmpLoaData] = useState({
    recordID: "",
    description: "",
  });
  const [bonotifyMode, setnotifyBomode] = useState("6");
  const [selectedFile, setSelectedFile] = useState();
  const [uploadFile, setUploadFile] = useState();
  const [ImageName, setImgName] = useState("");

  const AttachmentInitialValues = {
    code: Data.Code,
    description: Data.Name,
    LoaDescription: empLoaData.description,
    Sortorder: "",
  };
  const FnAttachment = async (values, resetForm, del) => {
    let action =
      laomode === "A" && !del
        ? "insert"
        : laomode === "E" && del
        ? "harddelete"
        : "update";

    console.log(values);

    const idata = {
      RecordID: empLoaData.recordID,
      EmployeeID: recID,
      Description: values.LoaDescription,
      //  ImageName: ImageName ? ImageName:Data.ImageName,
      Attachment: ImageName ? ImageName : Data.ImageName,
      Sortorder: "0",
    };
    console.log("save" + JSON.stringify(idata));

    const response = await dispatch(
      explorePostData({ accessID: "TR210", action, idata })
    );
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
      dispatch(
        fetchExplorelitview(
          "TR210",
          "List of Documents",
          `EmployeeID=${recID}`,
          ""
        )
      );
      resetForm();
      // SetEmpLoaData({
      //   RecordID: "",
      //   LoaDescription: "",
      //   Attachment: "",
      //   Sortorder:"0"
      // });
      setUploadFile("");
      selectCellRowData({ rowData: {}, mode: "A", field: "" });
      resetForm();
    } else {
      toast.error(response.payload.Msg);
    }
  };

  const getFileChange = async (event) => {
    setImgName(event.target.files[0]);

    console.log(event.target.files[0]);

    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("type", "attachments");

    const fileData = await dispatch(imageUpload({ formData }));
    setImgName(fileData.payload.name);

    if (fileData.payload.Status == "Y") {
      // console.log("I am here");
      toast.success(fileData.payload.Msg);
    }
  };
  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR027/my-profile");
        }
      } else {
        return;
      }
    });
  };
  return (
    <React.Fragment>
      <Box sx={{ height: "100vh", overflow: "auto" }}>
        <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0",height:"50px" }}>
          <Box display="flex" justifyContent="space-between" >
            {/* SEARCH BAR */}
            <Box
              display="flex"
              // backgroundColor={colors.primary[400]}
              borderRadius="3px"
              alignItems={"center"}
            >
              {broken && !rtl && (
                <IconButton onClick={() => toggleSidebar()}>
                  <MenuOutlinedIcon />
                </IconButton>
              )}
              <Box
                display={isNonMobile ? "flex" : "none"}
                borderRadius="3px"
                alignItems="center"
              >
                <Breadcrumbs
                  maxItems={3}
                  aria-label="breadcrumb"
                  separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                >
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default",marginLeft:"10px" }}
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    My-Profile
                  </Typography>
                  {show == "5" ? (
                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                    >
                      Contact
                    </Typography>
                  ) : (
                    false
                  )}
                  {show == "1" ? (
                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                    >
                      Skills
                    </Typography>
                  ) : (
                    false
                  )}
                  {show == "2" ? (
                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                    >
                      Functions
                    </Typography>
                  ) : (
                    false
                  )}
                  {show == "3" ? (
                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                    >
                      Managers
                    </Typography>
                  ) : (
                    false
                  )}
                  {show == "4" ? (
                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                    >
                      Deployment
                    </Typography>
                  ) : (
                    false
                  )}
                      {show == "10" ? (
                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                    >
                      Resignation
                    </Typography>
                  ) : (
                    false
                  )}
                  {show == "6" ? (
                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                    >
                      List of Documents
                    </Typography>
                  ) : (
                    false
                  )}
                  {show == "7" ? (
                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                    >
                      Item Custody
                    </Typography>
                  ) : (
                    false
                  )}
                  {show == "8" ? (
                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                    >
                      Leave Configuration
                    </Typography>
                  ) : (
                    false
                  )}
                </Breadcrumbs>
              </Box>
              {/* <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton> */}

              {/* {show=="2" ? <Typography variant="h3">Supplier Notification</Typography>:false} */}
            </Box>

            {/* ICONS */}

            <Box display="flex">
              {mode !== "A" ? (
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="demo-select-small">Explore</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={show}
                    label="Explore"
                    onChange={screenChange}
                  >
                    <MenuItem value={0}>My-Profile</MenuItem>
                    <MenuItem value={5}>Contact</MenuItem>
                    <MenuItem value={1}>Skills</MenuItem>
                    <MenuItem value={2}>Functions</MenuItem>
                    <MenuItem value={3}>Managers</MenuItem>
                    <MenuItem value={4}>Deployment</MenuItem>
                    <MenuItem value={8}>Leave Configuration</MenuItem>
                    <MenuItem value={9}>Approvals</MenuItem>
                    <MenuItem value={6}>List of Documents</MenuItem>
                    <MenuItem value={7}>Item Custody</MenuItem>
                    {/* <MenuItem value={10}>Resignation</MenuItem> */}
                    {/* <MenuItem value={8}>Change Password</MenuItem> */}
                  </Select>
                </FormControl>
              ) : (
                false
              )}

              <Tooltip title="Close">
                <IconButton onClick={() => fnLogOut("Close")} color="error">
                  <ResetTvIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Logout">
                <IconButton onClick={() => fnLogOut("Logout")} color="error">
                  <LogoutOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Paper>
        {show == "0" && !getLoading ? (
          <Paper elevation={3} sx={{ margin: "10px" }}>
            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              validationSchema={basicSchema}
            >
              {({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                setFieldValue,
              }) => (
                <form>
                  <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 4",
                      },
                    }}
                  >
                    {!isNonMobile && (
                      <Stack
                        sx={{
                          //    width: {sm:'100%',md:'100%',lg:'100%'},
                          gridColumn: "span 2",
                          alignContent: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          right: "0px",
                        }}
                      >
                        <Avatar
                          variant="rounded"
                          src={userimg}
                          sx={{ width: "200px", height: "150px" }}
                        />
                      </Stack>
                    )}

                    <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                      <FormControl
                        sx={{
                          gridColumn: "span 2",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Productautocomplete
                          name="department"
                          label="Department"
                          id="department"
                          value={values.department}
                          disabled
                          onChange={(newValue) => {
                            console.log("Selected Department:", newValue); // Debugging
                            setFieldValue("department", newValue); // Ensure newValue is an object
                          }}
                          //value={selectedProjectOptions}
                          //onChange={handleSelectionProjectname}
                          // defaultValue={selectedProjectName}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2010","ScreenName":"Department","Filter":"parentID=${compID}","Any":""}}`}
                        />
                      </FormControl>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        label="Code"
                        value={values.Code}
                        id="Code"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="Code"
                        // error={!!touched.Code && !!errors.Code}
                        // helperText={touched.Code && errors.Code}
                        sx={{ gridColumn: "span 2" }}
                        focused
                        required
                        autoFocus
                        inputProps={{ maxLength: 8 }}
                        InputProps={{ readOnly: true }}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        label="Name"
                        value={values.Name}
                        id="Name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="Name"
                        // error={!!touched.Name && !!errors.Name}
                        // helperText={touched.Name && errors.Name}
                        sx={{ gridColumn: "span 2" }}
                        focused
                        inputProps={{ maxLength: 90 }}
                        InputProps={{ readOnly: true }}
                        multiline
                      />
                      <TextField
                        fullWidth
                        variant="standard"
                        type="Password"
                        label="Password"
                        value={values.Password}
                        id="Password"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="Password"
                        InputProps={{ readOnly: true }}
                        // error={!!touched.Password && !!errors.Password}
                        // helperText={touched.Password && errors.Password}
                        focused
                      />
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        label="Job"
                        value={values.Job}
                        id="Job"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="Job"
                        error={!!touched.Job && !!errors.Job}
                        helperText={touched.Job && errors.Job}
                        focused
                        inputProps={{ maxLength: 90 }}
                        InputProps={{ readOnly: true }}
                      />

                      <TextField
                        select
                        fullWidth
                        variant="standard"
                        label={<span>Employee Type</span>}
                        value={values.employeetype}
                        id="employeetype"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="employeetype"
                        required
                        focused
                        InputProps={{ readOnly: true }}
                        sx={{
                          gridColumn: "span 2",
                          // backgroundColor: "#ffffff",
                          // "& .MuiInputBase-root": {
                          //   backgroundColor: "",
                          // },
                        }}
                      >
                        <MenuItem value="PP">Prohibition Period</MenuItem>
                        <MenuItem value="PM">Permanent</MenuItem>
                        <MenuItem value="CI">Contracts In</MenuItem>
                        <MenuItem value="CO">Contracts Out</MenuItem>
                        {/* <MenuItem value="CT">Contractor</MenuItem> */}
                      </TextField>
                         <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        label="Comments"
                        value={values.Comm}
                        id="Comm"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="Comm"
                        error={!!touched.Comm && !!errors.Comm}
                        helperText={touched.Comm && errors.Comm}
                        sx={{ gridColumn: "span 2" }}
                        focused
                        inputProps={{ maxLength: 90 }}
                        InputProps={{ readOnly: true }}
                        // multiline
                        // rows={2}
                      />
                      <FormControl>
                        <Box>
                          <Field
                            //  size="small"
                            type="checkbox"
                            name="Disable"
                            id="Disable"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            as={Checkbox}
                            label="Disable"
                            disabled
                          />

                          <FormLabel focused={false}>Disable</FormLabel>
                          <Field
                            //  size="small"
                            type="checkbox"
                            name="scrummaster"
                            id="scrummaster"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            as={Checkbox}
                            label="Scrum Master"
                            disabled
                          />

                          <FormLabel focused={false}>Scrum Master</FormLabel>
                          <Field
                            //  size="small"
                            type="checkbox"
                            name="prjmanager"
                            id="prjmanager"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            as={Checkbox}
                            label="Project Manager"
                            disabled
                          />

                          <FormLabel focused={false}>Project Manager</FormLabel>
                        </Box>
                      </FormControl>
                    </FormControl>

                    <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                      {isNonMobile && (
                        <Stack
                          sx={{
                            //    width: {sm:'100%',md:'100%',lg:'100%'},
                            gridColumn: "span 2",
                            alignContent: "center",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            right: "0px",
                          }}
                        >
                          <Avatar
                            variant="rounded"
                            src={userimg}
                            sx={{ width: "200px", height: "150px" }}
                          />
                        </Stack>
                      )}
                      <TextField
                        name="joindate"
                        type="date"
                        id="joindate"
                        label="Date of Joining"
                        variant="standard"
                        focused
                        inputFormat="YYYY-MM-DD"
                        value={values.joindate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.joindate && !!errors.joindate}
                        helperText={touched.joindate && errors.joindate}
                        sx={{ background: "" }}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ readOnly: true }}
                        //inputProps={{ max: new Date().toISOString().split("T")[0] }}
                      />
                      <TextField
                        name="confirmdate"
                        type="date"
                        id="confirmdate"
                        label="Date of Confirmation"
                        variant="standard"
                        focused
                        inputFormat="YYYY-MM-DD"
                        value={values.confirmdate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ readOnly: true }}
                        error={!!touched.confirmdate && !!errors.confirmdate}
                        helperText={touched.confirmdate && errors.confirmdate}
                        sx={{ background: "" }}
                        //inputProps={{ max: new Date().toISOString().split("T")[0] }}
                      />
                        <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      label="Notice Period"
                      // label={
                      //   <>
                      //     Notice Period
                      //     <span style={{ color: "red", fontSize: "20px" }}>
                      //       {" "}
                      //       *{" "}
                      //     </span>
                      //   </>
                      // }
                      value={values.noticeperiod}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="noticeperiod"
                      error={!!touched.noticeperiod && !!errors.noticeperiod}
                      helperText={touched.noticeperiod && errors.noticeperiod}
                      focused
                      inputProps={{ maxLength: 15 }}
                    />
                   
                      {/* <TextField
                        fullWidth
                        variant="standard"
                        type="number"
                        label="Salary"
                        value={values.Sal}
                        id="Sal"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="Sal"
                        error={!!touched.Sal && !!errors.Sal}
                        helperText={touched.Sal && errors.Sal}
                        sx={{ gridColumn: "span 2", background: "" }}
                        focused
                        onInput={(e) => {
                          e.target.value = Math.max(0, parseInt(e.target.value))
                            .toString()
                            .slice(0, 8);
                        }}
                        InputProps={{
                          inputProps: {
                            style: { textAlign: "right" },
                          },
                        }}
                      /> */}

                      <TextField
                        fullWidth
                        variant="standard"
                        type="number"
                        label="Sort Order"
                        value={values.SortOrder}
                        id="SortOrder"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="SortOrder"
                        error={!!touched.SortOrder && !!errors.SortOrder}
                        helperText={touched.SortOrder && errors.SortOrder}
                        sx={{ gridColumn: "span 2", background: "" }}
                        focused
                        onInput={(e) => {
                          e.target.value = Math.max(0, parseInt(e.target.value))
                            .toString()
                            .slice(0, 8);
                        }}
                        InputProps={{
                          readOnly: true,
                          inputProps: {
                            style: { textAlign: "right" },
                          },
                        }}
                      />
                    </FormControl>

           

                  </Box>
                            <Divider variant="fullWidth" sx={{ mt: "20px" }} />
                  <Typography
                  padding={1}
                  variant="h4">Resignation Details</Typography>

   <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                    // gap="30px"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 2",
                      },
                    }}
                  >
                  
                  
                         <Box sx={{ width: "100%" }}>
                      <FormControl
                       inputProps={{ readOnly: true }}
                        sx={{
                          //gridColumn: "span 2",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                          <TextField
                          name="resignationdate"
                          type="date"
                          id="resignationdate"
                          label="Resignation Date"
                        fullWidth
                        variant="standard"
                        inputFormat="YYYY-MM-DD"
                        value={values.resignationdate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.resignationdate && !!errors.resignationdate}
                        helperText={touched.resignationdate && errors.resignationdate}
                        // sx={{

                        //   backgroundColor: "#ffffff", // Set the background to white
                        //   "& .MuiFilledInput-root": {
                        //     backgroundColor: "", // Ensure the filled variant also has a white background
                        //   }
                        // }}
                        focused
                        inputProps={{ maxLength: 90,readOnly: true }}

                      />
                        {/* <CheckinAutocomplete
                          name="location"
                          label={
                            <span>
                              Location
                              <span style={{ color: "red", fontSize: "20px" }}>
                                *
                              </span>
                            </span>
                          }
                          variant="outlined"
                          id="location"
                          // value={locationLookup}
                          value={values.location}
                          onChange={(newValue) => {
                            setFieldValue("location", newValue);
                            // SetLocationLookup({
                            //   RecordID: newValue.RecordID,
                            //   Code: newValue.Code,
                            //   Name: newValue.Name,
                            // });
                          }}
                          error={!!touched.location && !!errors.location}
                          helperText={touched.location && errors.location}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2051","ScreenName":"Location","Filter":"parentID='${CompanyID}'","Any":""}}`}
                        /> */}
                      </FormControl>
                    </Box>
                    <Box sx={{ width: "100%" }}>
                      <FormControl
                       
                        sx={{
                          //gridColumn: "span 2",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                          <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        label="Resignation Note"
                        value={values.resignationnote}
                        id="resignationnote"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="resignationnote"
                        error={!!touched.resignationnote && !!errors.resignationnote}
                        helperText={touched.resignationnote && errors.resignationnote}
                        focused
                        inputProps={{ maxLength: 90,readOnly: true }}
                        multiline
                      // rows={2}
                      />
                        {/* <CheckinAutocomplete
                          name="location"
                          label={
                            <span>
                              Location
                              <span style={{ color: "red", fontSize: "20px" }}>
                                *
                              </span>
                            </span>
                          }
                          variant="outlined"
                          id="location"
                          // value={locationLookup}
                          value={values.location}
                          onChange={(newValue) => {
                            setFieldValue("location", newValue);
                            // SetLocationLookup({
                            //   RecordID: newValue.RecordID,
                            //   Code: newValue.Code,
                            //   Name: newValue.Name,
                            // });
                          }}
                          error={!!touched.location && !!errors.location}
                          helperText={touched.location && errors.location}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2051","ScreenName":"Location","Filter":"parentID='${CompanyID}'","Any":""}}`}
                        /> */}
                      </FormControl>
                    </Box>

                    <FormControl
                    inputProps={{ readOnly: true }}
                      sx={{
                        //gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Productautocomplete
                        name="exitinterviewby"
                        label={
                          <span>
                           Exit Interview By
                            <span style={{ color: "red", fontSize: "20px" }}>
                              *
                            </span>
                          </span>
                        }
                        variant="outlined"
                        id="exitinterviewby"
                        // value={exitinterviewbyLookup}
                        value={values.exitinterviewby}
                         readOnly
                          onOpen={(e) => e.preventDefault()}
                        onChange={(newValue) => {
                          setFieldValue("exitinterviewby", newValue);
                          console.log(newValue, "--newvalue exitinterviewby");
                          console.log(newValue.RecordID, "exitinterviewby RecordID");

                          // SetGateLookup({
                          //   RecordID: newValue.RecordID,
                          //   Code: newValue.Code,
                          //   Name: newValue.Name,
                          // });
                        }}
                        error={!!touched.exitinterviewby && !!errors.exitinterviewby}
                        helperText={touched.exitinterviewby && errors.exitinterviewby}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2165","ScreenName":"Exit Interview By","Filter":"CompanyID='${compID}'","Any":""}}`}
                      />
                    </FormControl>

                    <FormControl
                      sx={{
                        //gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                        <TextField
                          name="exitinterviewdate"
                          type="date"
                          id="exitinterviewdate"
                          label="Exit Interview Date"
                        fullWidth
                        variant="standard"
                        inputFormat="YYYY-MM-DD"
                        value={values.exitinterviewdate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.exitinterviewdate && !!errors.exitinterviewdate}
                        helperText={touched.exitinterviewdate && errors.exitinterviewdate}
                        // sx={{

                        //   backgroundColor: "#ffffff", // Set the background to white
                        //   "& .MuiFilledInput-root": {
                        //     backgroundColor: "", // Ensure the filled variant also has a white background
                        //   }
                        // }}
                        focused
                        inputProps={{ maxLength: 90,readOnly: true }}

                      />

                      {/* <CheckinAutocomplete
                        id="function"
                        name="function"
                        label="Function"
                        // label={
                        //   <span>
                        //     Function
                        //     <span style={{ color: "red", fontSize: "20px" }}>
                        //       *
                        //     </span>
                        //   </span>
                        // }
                        variant="outlined"
                        value={values.function}
                        onChange={(newValue) => {
                          setFieldValue("function", newValue);
                          console.log(newValue, "--newvalue function");
                          console.log(newValue.RecordID, "function RecordID");
                        }}
                        // error={!!touched.function && !!errors.function}
                        // helperText={touched.function && errors.function}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2048","ScreenName":"Function","Filter":"CompanyID
 ='${CompanyID}'","Any":""}}`}
                      /> */}
                    </FormControl>

                     

                    <FormControl
                      sx={{
                        //gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                          <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        label="Exit Interview Comments"
                        value={values.exitinterviewcomments}
                        id="exitinterviewcomments"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="exitinterviewcomments"
                        error={!!touched.exitinterviewcomments && !!errors.exitinterviewcomments}
                        helperText={touched.exitinterviewcomments && errors.exitinterviewcomments}
                        focused
                        inputProps={{ maxLength: 90,readOnly: true }}
                        multiline
                      // rows={2}
                      />
                      </FormControl>



                        <FormControl
                      sx={{
                        //gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                        <TextField
                          name="acceptedrelievingdate"
                          type="date"
                          id="acceptedrelievingdate"
                          label="Accepted Relieving Date"
                        fullWidth
                        variant="standard"
                        inputFormat="YYYY-MM-DD"
                        value={values.acceptedrelievingdate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.acceptedrelievingdate && !!errors.acceptedrelievingdate}
                        helperText={touched.acceptedrelievingdate && errors.acceptedrelievingdate}
                        focused
                        inputProps={{ maxLength: 90, readOnly: true }}

                      />

                    </FormControl>
                     <FormControl
                      sx={{
                        //gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                        <TextField
                          name="actualrelievingdate"
                          type="date"
                          id="actualrelievingdate"
                          label="Actual Relieving Date"
                        fullWidth
                        variant="standard"
                        inputFormat="YYYY-MM-DD"
                        value={values.actualrelievingdate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.actualrelievingdate && !!errors.actualrelievingdate}
                        helperText={touched.actualrelievingdate && errors.actualrelievingdate}
                        focused
                        inputProps={{ maxLength: 90, readOnly: true }}

                      />

                    </FormControl>
                     <FormControl
                      sx={{
                        //gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                        <TextField
                          name="dateofsettlement"
                          type="date"
                          id="dateofsettlement"
                          label="Date Of Settlement"
                        fullWidth
                        variant="standard"
                        inputFormat="YYYY-MM-DD"
                        value={values.dateofsettlement}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.dateofsettlement && !!errors.dateofsettlement}
                        helperText={touched.dateofsettlement && errors.dateofsettlement}
                        focused
                        inputProps={{ maxLength: 90, readOnly: true }}

                      />

                    </FormControl>
                     <Box>
                      <Field
                        //  size="small"
                        type="checkbox"
                        name="exitformalitiesacceptrd"
                        id="exitformalitiesacceptrd"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        as={Checkbox}
                        label="exitformalitiesacceptrd"
                      disabled
                      />

                      <FormLabel focused={false}>
                        Exit Formalities Accepted
                      </FormLabel>
                           </Box>
                  </Box>
                  <Box
                    display="flex"
                    padding={1}
                    justifyContent="end"
                    mt="20px"
                    gap={2}
                  >
                    {/* {YearFlag == "true" ? ( */}
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={loading}
                      onClick={() => {
                        fnSave(values);
                      }}
                      disabled
                    >
                      Save
                    </LoadingButton>
                    {/* <Button
                    disabled
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        navigate(`/Apps/TR027/Employees`);
                      }}
                    >
                      Cancel
                    </Button> */}
                  </Box>
                  <Popup
                    title="Department"
                    openPopup={openDEPopup}
                    setOpenPopup={setOpenDEPopup}
                  >
                    <Listviewpopup
                      accessID="2010"
                      screenName="Department"
                      childToParent={childToParent}
                    />
                  </Popup>
                  <Popup
                    title="Location"
                    openPopup={openLOCATIONPopup}
                    setOpenPopup={setOpenLOCATIONPopup}
                  >
                    <Listviewpopup
                      accessID="2051"
                      screenName="Location"
                      childToParent={childToParent}
                    />
                  </Popup>
                  <Popup
                    title="Gate"
                    openPopup={openGATEPopup}
                    setOpenPopup={setOpenGATEPopup}
                  >
                    <Listviewpopup
                      accessID="2050"
                      screenName="Gate"
                      childToParent={childToParent}
                    />
                  </Popup>
                  <Popup
                    title="Designation"
                    openPopup={opendesignPopup}
                    setOpenPopup={setOpendesignPopup}
                  >
                    <Listviewpopup
                      accessID="2047"
                      screenName="Designation"
                      childToParent={childToParent}
                    />
                  </Popup>
                </form>
              )}
            </Formik>
            {/* </Box> */}
          </Paper>
        ) : (
          false
        )}
        {show == "8" ? (
          <Paper elevation={3} sx={{ margin: "10px" }}>
            <Formik
              initialValues={LCInitialValue}
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                setTimeout(() => {
                  LCsaveFn(values, resetForm, false);
                }, 100);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
                resetForm,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  onReset={() => {
                    selectCellRowData({ rowData: {}, mode: "A", field: "" });
                    resetForm();
                  }}
                >
                  <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                    // gap="30px"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 2",
                      },
                    }}
                  >
                    {!isNonMobile && (
                      <Stack
                        sx={{
                          //    width: {sm:'100%',md:'100%',lg:'100%'},
                          //gridColumn: "span 2",
                          alignContent: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          right: "0px",
                        }}
                      >
                        <Avatar
                          variant="rounded"
                          src={userimg}
                          sx={{ width: "200px", height: "150px" }}
                        />
                      </Stack>
                    )}
                    {/* <Stack
                      sx={{
                        gap: formGap,
                        alignContent: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        right: "0px",
                      }}
                    >
                      <Avatar
                        variant="rounded"
                        src={userimg}
                        sx={{ width: "200px", height: "120px" }}
                      />
                    </Stack> */}
                    <FormControl sx={{ gap: formGap }}>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        inputProps={{ maxLength: 8 }}
                        value={values.Code}
                        id="Code"
                        name="Code"
                        label="Code"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        sx={{
                          // gridColumn: "span 2",
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                          },
                        }}
                        focused
                        InputProps={{ readOnly: true }}
                        //  error={!!touched.Desc && !!errors.Desc}
                        //  helperText={touched.Desc && errors.Desc}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        label="Name"
                        value={values.Name}
                        id="Name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="Name"
                        error={!!touched.Name && !!errors.Name}
                        helperText={touched.Name && errors.Name}
                        sx={{
                          //gridColumn: "span 2",
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                          },
                        }}
                        focused
                        inputProps={{ maxLength: 90, readOnly: true }}
                        multiline
                      />

                      <Box
                        m="5px 0 0 0"
                        //height={dataGridHeight}
                        height="50vh"
                        sx={{
                          "& .MuiDataGrid-root": {
                            border: "none",
                          },
                          "& .MuiDataGrid-cell": {
                            borderBottom: "none",
                          },
                          "& .name-column--cell": {
                            color: colors.greenAccent[300],
                          },
                          "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: colors.blueAccent[800],
                            borderBottom: "none",
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            backgroundColor: colors.primary[400],
                          },
                          "& .MuiDataGrid-footerContainer": {
                            borderTop: "none",
                            backgroundColor: colors.blueAccent[800],
                          },
                          "& .MuiCheckbox-root": {
                            color: `${colors.greenAccent[200]} !important`,
                          },
                          "& .odd-row": {
                            backgroundColor: "",
                            color: "", // Color for odd rows
                          },
                          "& .even-row": {
                            backgroundColor: "#D3D3D3",
                            color: "", // Color for even rows
                          },
                        }}
                      >
                        <DataGrid
                          sx={{
                            "& .MuiDataGrid-footerContainer": {
                              height: dataGridHeaderFooterHeight,
                              minHeight: dataGridHeaderFooterHeight,
                            },
                          }}
                          rows={explorelistViewData}
                          columns={columns}
                          disableSelectionOnClick
                          getRowId={(row) => row.RecordID}
                          rowHeight={dataGridRowHeight}
                          headerHeight={dataGridHeaderFooterHeight}
                          pageSize={pageSize}
                          onPageSizeChange={(newPageSize) =>
                            setPageSize(newPageSize)
                          }
                          rowsPerPageOptions={[5, 10, 20]}
                          pagination
                          onCellClick={(params) => {
                            selectCellRowData({
                              rowData: params.row,
                              mode: "E",
                              field: params.field,
                            });
                          }}
                          components={{
                            Toolbar: Employee,
                          }}
                          onStateChange={(stateParams) =>
                            setRowCount(stateParams.pagination.rowCount)
                          }
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "odd-row"
                              : "even-row"
                          }
                          componentsProps={{
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                            },
                          }}
                        />
                      </Box>
                    </FormControl>
                    <FormControl
                      sx={{
                        //mt: "15px",
                        gap: formGap,
                        marginTop: "20px",
                      }}
                    >
                      <FormControl
                        sx={{
                          gap: formGap,
                        }}
                        style={{ width: "100%" }}
                      >
                        {isNonMobile && (
                          <Stack
                            sx={{
                              //    width: {sm:'100%',md:'100%',lg:'100%'},
                              //gridColumn: "span 2",
                              alignContent: "center",
                              justifyContent: "center",
                              alignItems: "center",
                              position: "relative",
                              right: "0px",
                            }}
                          >
                            <Avatar
                              variant="rounded"
                              src={userimg}
                              sx={{ width: "200px", height: "120px" }}
                            />
                          </Stack>
                        )}

                        <FormControl
                          focused
                          variant="filled"
                          sx={{ gridColumn: "span 2" }}
                        >
                          {/* <InputLabel variant="standard" id="LeavePart">
                                  {
                                    <span>
                                      Leave Part{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </span>
                                  }
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-filled-label"
                                  fullWidth
                                  variant="standard"
                                  type="text"
                                  // value={values.LeavePart}
                                  id="LeavePart"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  name="LeavePart"
                                  required
                                  focused
                                >
                                  <MenuItem value="FH">First Half</MenuItem>
                                  <MenuItem value="SH">Second Half</MenuItem>
                                  <MenuItem value="N">Full Day</MenuItem>
                                </Select> */}
                          <Productautocomplete
                            name="leavetype"
                            label="Leave Type"
                            id="leavetype"
                            // value={values.leavetype}
                            value={LeaveconLTData}
                            // disabled
                            readOnly
                            onOpen={(e) => e.preventDefault()}
                            onChange={(newValue) => {
                              // setFieldValue("leavetype", newValue);
                              setselectLeaveconLTData({
                                RecordID: newValue.RecordID,
                                Code: newValue.Code,
                                Name: newValue.Name,
                              });
                              console.log(newValue, "--newValue");
                            }}
                            // disabled={mode == "E" && values.Status != "AL"}
                            //value={selectedProjectOptions}
                            //onChange={handleSelectionProjectname}
                            // defaultValue={selectedProjectName}
                            url={`${listViewurl}?data={"Query":{"AccessID":"2092","ScreenName":"Leave Type","Filter":"parentID='${compID}'","Any":""}}`}
                          />
                        </FormControl>

                        {/* <TextField
                                fullWidth
                                variant="standard"
                                type="text"
                                value={values.employeename}
                                id="employeename"
                                name="employeename"
                                label="Employee Name"
                                // required
                                onBlur={handleBlur}
                                onChange={handleChange}
                                error={!!touched.employeename && !!errors.employeename}
                                helperText={touched.employeename && errors.employeename}
                                sx={{
                                  //gridColumn: "span 2",
                                  backgroundColor: "#ffffff", // Set the background to white
                                  "& .MuiFilledInput-root": {
                                    backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                                  },
                                }}
                                focused
                                multiline
                                inputProps={{ maxLength: 90 }}
                              /> */}

                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          // label="Total Days"
                          label="Eligible Days"
                          id="totaldays"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.totaldays}
                          name="totaldays"
                          error={!!touched.totaldays && !!errors.totaldays}
                          helperText={touched.totaldays && errors.totaldays}
                          // sx={{ gridColumn: "span 2" }}
                          focused
                          onWheel={(e) => e.target.blur()}
                          InputProps={{
                            readOnly: true,
                            inputProps: {
                              style: {
                                textAlign: "right",
                                //background: "#fff6c3",
                              },
                            },
                          }}
                          // onInput={(e) => {
                          //   e.target.value = Math.max(
                          //     0,
                          //     parseInt(e.target.value)
                          //   )
                          //     .toString()
                          //     .slice(0, 8);
                          // }}
                        />
                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          label="Availed Days"
                          id="availableleave"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.availableleave}
                          name="availableleave"
                          error={
                            !!touched.availableleave && !!errors.availableleave
                          }
                          helperText={
                            touched.availableleave && errors.availableleave
                          }
                          // sx={{ gridColumn: "span 2" }}
                          focused
                          onWheel={(e) => e.target.blur()}
                          InputProps={{
                            readOnly: true,
                            inputProps: {
                              style: {
                                textAlign: "right",
                                //background: "#fff6c3",
                              },
                            },
                          }}
                          // onInput={(e) => {
                          //   e.target.value = Math.max(
                          //     0,
                          //     parseInt(e.target.value)
                          //   )
                          //     .toString()
                          //     .slice(0, 8);
                          // }}
                        />
                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          label="Balance Days"
                          id="elligibledays"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          // value={values.elligibledays}
                          value={
                            Number(values.totaldays) -
                            Number(values.availableleave)
                          }
                          name="elligibledays"
                          error={
                            !!touched.elligibledays && !!errors.elligibledays
                          }
                          helperText={
                            touched.elligibledays && errors.elligibledays
                          }
                          focused
                          onWheel={(e) => e.target.blur()}
                          InputProps={{
                            readOnly: true,
                            inputProps: {
                              style: { textAlign: "right" },
                            },
                          }}
                        />
                        <TextField
                          select
                          fullWidth
                          variant="standard"
                          label={<span>Year</span>}
                          value={values.Year}
                          id="Year"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          name="Year"
                          // required
                          focused
                          InputProps={{ readOnly: true }}
                          // sx={{
                          //   gridColumn: "span 2",
                          //   backgroundColor: "#ffffff",
                          //   "& .MuiInputBase-root": {
                          //     backgroundColor: "",
                          //   },
                          // }}
                        >
                          <MenuItem value="2024">2024</MenuItem>
                          <MenuItem value="2025">2025</MenuItem>
                          <MenuItem value="2026">2026</MenuItem>
                          {/* <MenuItem value="PY">2024</MenuItem>
                        <MenuItem value="CY">2025</MenuItem>
                        <MenuItem value="NY">2026</MenuItem> */}
                        </TextField>
                      </FormControl>

                      <Box
                        display="flex"
                        justifyContent="end"
                        padding={1}
                        gap={2}
                        mt={10}
                      >
                        {/* {YearFlag == "true" ? ( */}
                        <LoadingButton
                          color="secondary"
                          variant="contained"
                          type="submit"
                          loading={isLoading}
                          disabled
                        >
                          Save
                        </LoadingButton>
                        {/* ) : (
                                <Button
                                  color="secondary"
                                  variant="contained"
                                  disabled={true}
                                  
                                >
                                  Save
                                </Button>
                     )}
                              {YearFlag == "true" ? (  */}
                        <Button
                          color="error"
                          variant="contained"
                          disabled
                          onClick={() => {
                            Swal.fire({
                              title: `Do you want Delete?`,
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonColor: "#3085d6",
                              cancelButtonColor: "#d33",
                              confirmButtonText: "Confirm",
                            }).then((result) => {
                              if (result.isConfirmed) {
                                LCsaveFn(values, resetForm, "harddelete");
                              } else {
                                return;
                              }
                            });
                          }}
                        >
                          Delete
                        </Button>
                        {/* ) : (
                                <Button
                                  color="error"
                                  variant="contained"
                                  disabled={true}
                                >
                                  Delete
                                </Button>
                              )}  */}
                        <Button
                          type="reset"
                          color="warning"
                          variant="contained"
                          onClick={() => {
                            setScreen(0);
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </FormControl>
                  </Box>
                </form>
              )}
            </Formik>
          </Paper>
        ) : (
          false
        )}
        {show == "5" ? (
          <Paper elevation={3} sx={{ margin: "10px" }}>
            {/* <Box m="10px"> */}
            <Formik
              initialValues={contactInitialvalues}
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                setTimeout(() => {
                  fncontact(values, resetForm, false);
                }, 100);
              }}
              validationSchema={contactshema}
            >
              {({
                errors,
                touched,
                handleBlur,
                handleChange,
                isSubmitting,
                values,
                handleSubmit,
                resetForm,
                setFieldValue,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  onReset={() => {
                    selectCellRowData({ rowData: {}, mode: "A", field: "" });
                    resetForm();
                  }}
                >
                  <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 4",
                      },
                    }}
                  >
                    <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        inputProps={{ maxLength: 8, readOnly: true }}
                        value={values.Code}
                        id="Code"
                        name="Code"
                        label="Code"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        sx={{ gridColumn: "span 2" }}
                        focused

                        //  error={!!touched.Desc && !!errors.Desc}
                        //  helperText={touched.Desc && errors.Desc}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        label="Name"
                        value={values.Name}
                        id="Name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="Name"
                        error={!!touched.Name && !!errors.Name}
                        helperText={touched.Name && errors.Name}
                        sx={{ gridColumn: "span 2" }}
                        focused
                        inputProps={{ maxLength: 90, readOnly: true }}
                        multiline
                      />
                    </FormControl>
                    {isNonMobile && (
                      <Stack
                        sx={{
                          //    width: {sm:'100%',md:'100%',lg:'100%'},
                          gridColumn: "span 2",
                          alignContent: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          right: "0px",
                        }}
                      >
                        <Avatar
                          variant="rounded"
                          src={userimg}
                          sx={{ width: "200px", height: "120px" }}
                        />
                      </Stack>
                    )}
                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      label="phonenumber"
                      // required
                      onInvalid={(e) => {
                        e.target.setCustomValidity(
                          "Please Fill The phonenumber"
                        );
                      }}
                      value={values.phonenumber}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="phonenumber"
                      sx={{ gridColumn: "span 2" }}
                      focused
                      inputProps={{ readOnly: true }}
                      error={!!touched.phonenumber && !!errors.phonenumber}
                      helperText={touched.phonenumber && errors.phonenumber}
                      // inputProps={{maxLength: 10}}
                      onInput={(e) => {
                        // e.target.value = Math.max(0, parseInt(e.target.value))
                        //   .toString()
                        //   .slice(0, 11);

                        e.target.setCustomValidity("");
                      }}
                    />
                    {/* <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="email"
                      name="email"
                      required
                      value={values.email}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      label="Email Id"
                      focused
                      sx={{ gridColumn: "span 2" }}
                    /> */}
                    <TextField
                      fullWidth
                      variant="standard"
                      type="email"
                      label="Email Id"
                      required
                      onInvalid={(e) => {
                        e.target.setCustomValidity("Please Fill The Email Id");
                      }}
                      onInput={(e) => {
                        e.target.setCustomValidity("");
                      }}
                      value={values.email}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="email"
                      sx={{ gridColumn: "span 2" }}
                      focused
                      inputProps={{ maxLength: 45, readOnly: true }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      id="aadharcardnumber"
                      name="aadharcardnumber"
                      // required
                      value={values.aadharcardnumber}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      label="Aadhar Card No"
                      focused
                      sx={{ gridColumn: "span 2" }}
                      inputProps={{ readOnly: true }}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      id="pfnumber"
                      name="pfnumber"
                      // required
                      value={values.pfnumber}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      label="PF No"
                      focused
                      sx={{ gridColumn: "span 2" }}
                      inputProps={{ readOnly: true }}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      // required
                      type="number"
                      id="esinumber"
                      name="esinumber"
                      inputFormat="HH:mm:aa"
                      value={values.esinumber}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      label="ESI No"
                      focused
                      sx={{ gridColumn: "span 2" }}
                      inputProps={{ readOnly: true }}
                    />
                    <TextField
                      fullWidth
                      // required
                      variant="standard"
                      type="text"
                      id="permanentaddress"
                      name="permanentaddress"
                      multiline
                      value={values.permanentaddress}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      label="Permanent Address"
                      focused
                      sx={{ gridColumn: "span 2" }}
                      inputProps={{ readOnly: true }}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="localaddress"
                      name="localaddress"
                      multiline
                      required
                      value={values.localaddress}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      label="Local Address"
                      focused
                      sx={{ gridColumn: "span 2" }}
                      inputProps={{ readOnly: true }}
                    />
                  </Box>

                  <Box
                    display="flex"
                    padding={1}
                    justifyContent="end"
                    mt="30px"
                    gap={2}
                  >
                    {/* {YearFlag == "true" ? ( */}
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={isLoading}
                      disabled
                    >
                      Save
                    </LoadingButton>
                    {/* ) : (
                      <Button
                        color="secondary"
                        variant="contained"
                        disabled={true}
                      >
                        Save
                      </Button>
                    )} */}
                    {/* {YearFlag == "true" ? (
                      <Button
                        onClick={() => mgrFunctionFn(values, resetForm, true)}
                        color="error"
                        variant="contained"
                      >
                        Delete
                      </Button>
                    ) : (
                      <Button color="error" variant="contained" disabled={true}>
                        Delete
                      </Button>
                    )} */}
                    <Button
                      type="reset"
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        setScreen(0);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </form>
              )}
            </Formik>
            {/* </Box> */}
          </Paper>
        ) : (
          false
        )}
        {show == "1" ? (
          <Paper elevation={3} sx={{ margin: "10px" }}>
            {/* <Box m="20px" sx={{ m: 2 }}> */}
            <Formik
              // onSubmit={handleFormSubmit}
              initialValues={initialValues}
              enableReinitialize={true}
              validationSchema={basicSchema}
            >
              {({ values, errors, touched, handleBlur, handleChange }) => (
                <form>
                  <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 4",
                      },
                    }}
                  >
                    <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        inputProps={{ maxLength: 8 }}
                        value={values.Code}
                        id="Code"
                        name="Code"
                        label="Code"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        sx={{ gridColumn: "span 2" }}
                        focused
                        InputProps={{ readOnly: true }}

                        //  error={!!touched.Desc && !!errors.Desc}
                        //  helperText={touched.Desc && errors.Desc}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        label="Name"
                        value={values.Name}
                        id="Name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="Name"
                        error={!!touched.Name && !!errors.Name}
                        helperText={touched.Name && errors.Name}
                        sx={{ gridColumn: "span 2" }}
                        focused
                        inputProps={{ maxLength: 90, readOnly: true }}
                        multiline
                      />

                      {/* {!isNonMobile && (
                      <Stack
                        sx={{
                          //    width: {sm:'100%',md:'100%',lg:'100%'},
                          gridColumn: "span 2",
                          alignContent: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          right: "0px",
                        }}
                      >
                        <Avatar
                          variant="rounded"
                          src={userimg}
                          sx={{ width: "200px", height: "150px" }}
                        />
                      </Stack>
                    )} */}
                      <Box m="5px">
                        <Box
                          m="5px 0 0 0"
                          height="55vh"
                          sx={{
                            "& .MuiDataGrid-root": {
                              border: "none",
                            },
                            "& .MuiDataGrid-cell": {
                              borderBottom: "none",
                            },
                            "& .name-column--cell": {
                              color: colors.greenAccent[300],
                            },
                            "& .MuiDataGrid-columnHeaders": {
                              backgroundColor: colors.blueAccent[800],
                              borderBottom: "none",
                            },
                            "& .MuiDataGrid-virtualScroller": {
                              backgroundColor: colors.primary[400],
                            },
                            "& .MuiDataGrid-footerContainer": {
                              borderTop: "none",
                              backgroundColor: colors.blueAccent[800],
                            },
                            "& .MuiCheckbox-root": {
                              color: `${colors.greenAccent[200]} !important`,
                            },
                            "& .odd-row": {
                              backgroundColor: "",
                              color: "", // Color for odd rows
                            },
                            "& .even-row": {
                              backgroundColor: "#d0edec",
                              color: "", // Color for even rows
                            },
                          }}
                        >
                          <DataGrid
                            sx={{
                              "& .MuiDataGrid-footerContainer": {
                                height: dataGridHeaderFooterHeight,
                                minHeight: dataGridHeaderFooterHeight,
                              },
                            }}
                            rowHeight={dataGridRowHeight}
                            headerHeight={dataGridHeaderFooterHeight}
                            // checkboxSelection
                            rows={explorelistViewData}
                            columns={columns}
                            disableSelectionOnClick
                            getRowId={(row) => row.RecordID}
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) =>
                              setPageSize(newPageSize)
                            }
                            rowsPerPageOptions={[5, 10, 20]}
                            pagination
                            onCellClick={(params) => {
                              const currentRow = params.row;
                              const currentcellField = params.field;
                              selectcelldata(currentRow, "E", currentcellField);
                              console.log(JSON.stringify(params));
                            }}
                            components={{
                              Toolbar: Custombar,
                            }}
                            onStateChange={(stateParams) =>
                              setRowCount(stateParams.pagination.rowCount)
                            }
                            componentsProps={{
                              toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 },
                              },
                            }}
                            getRowClassName={(params) =>
                              params.indexRelativeToCurrentPage % 2 === 0
                                ? "odd-row"
                                : "even-row"
                            }
                          />
                        </Box>
                      </Box>
                    </FormControl>
                    <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                      <Formik
                        initialValues={supprocessInitialvalues}
                        enableReinitialize={iniProcess}
                        validationSchema={basicSchema}
                        onSubmit={async (values) => {
                          alert("submit", values);
                        }}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleBlur,
                          handleChange,
                          resetForm,
                          setFieldValue,
                        }) => (
                          <form>
                            <FormControl
                              sx={{ gridColumn: "span 2" }}
                              style={{ width: "100%" }}
                            >
                              {isNonMobile && (
                                <Stack
                                  sx={{
                                    //    width: {sm:'100%',md:'100%',lg:'100%'},
                                    gridColumn: "span 2",
                                    alignContent: "center",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    position: "relative",
                                    right: "0px",
                                  }}
                                >
                                  <Avatar
                                    variant="rounded"
                                    src={userimg}
                                    sx={{ width: "200px", height: "150px" }}
                                  />
                                </Stack>
                              )}

                              <FormControl
                                sx={{
                                  gridColumn: "span 2",
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  marginTop: "20px",
                                }}
                              >
                                {/* <Productautocomplete
                                  name="process"
                                  label="Process"
                                  id="process"
                                  value={values.process}
                                  disabled
                                  onChange={(newValue) => {
                                    setFieldValue("process", newValue);
                                  }}
                                  //value={selectedProjectOptions}
                                  //onChange={handleSelectionProjectname}
                                  // defaultValue={selectedProjectName}
                                  url={`${listViewurl}?data={"Query":{"AccessID":"2001","ScreenName":"Process","Filter":"","Any":""}}`}
                                /> */}
                                 <TextField
                                fullWidth
                                variant="standard"
                                type="text"
                                value={values.skills}
                                id="skills"
                                name="skills"
                                // disabled
                                label="Skills"
                                // label={
                                //   <>
                                //     Skills
                                //     <span
                                //       style={{ color: "red", fontSize: "20px" }}
                                //     >
                                //       *
                                //     </span>
                                //   </>
                                // }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                error={!!touched.skills && !!errors.skills}
                                helperText={touched.skills && errors.skills}
                                sx={{
                                  //gridColumn: "span 2",
                                  backgroundColor: "#ffffff", 
                                  "& .MuiFilledInput-root": {
                                    backgroundColor: "#ffffff", 
                                  },
                                }}
                                focused                               
                                multiline
                                 inputProps={{ maxLength: 90, readOnly: true }}
                              />
                                
                              </FormControl>
 <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                              <TextField
                                fullWidth
                                variant="standard"
                                type="text"
                                value={values.Comments}
                                id="Comments"
                                name="Comments"
                                label="Comments"
                                // required
                                onBlur={handleBlur}
                                onChange={handleChange}
                                error={!!touched.Comments && !!errors.Comments}
                                helperText={touched.Comments && errors.Comments}
                                sx={{
                                  gridColumn: "span 2",
                                  mt: 1
                                }}
                                focused
                                multiline
                                inputProps={{ maxLength: 90, readOnly: true }}
                              />

                              <TextField
                                fullWidth
                                variant="standard"
                                type="number"
                                label="Sort Order"
                                id="SortOrder"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.SortOrder}
                                name="SortOrder"
                                error={
                                  !!touched.SortOrder && !!errors.SortOrder
                                }
                                helperText={
                                  touched.SortOrder && errors.SortOrder
                                }
                                sx={{ gridColumn: "span 2" }}
                                focused
                                InputProps={{
                                  inputProps: {
                                    style: {
                                      textAlign: "right",
                                      background: "",
                                    },
                                  },
                                  readOnly: true,
                                }}
                                onInput={(e) => {
                                  e.target.value = Math.max(
                                    0,
                                    parseInt(e.target.value)
                                  )
                                    .toString()
                                    .slice(0, 8);
                                }}
                              />
                              </FormControl>
                              {/* <FormControlLabel  control={ <Field type="checkbox" name="checkbox" id="checkbox"  label="Disable" />} label="Disable" /> */}
                            </FormControl>

                            <Box
                              display="flex"
                              justifyContent="end"
                              mt="130px"
                              padding={1}
                              gap={2}
                            >
                              {/* {YearFlag == "true" ? ( */}
                              <LoadingButton
                                color="secondary"
                                variant="contained"
                                type="submit"
                                loading={loading}
                                onClick={() => {
                                  fnProcess(values, resetForm, "");
                                }}
                                disabled
                              >
                                Save
                              </LoadingButton>
                              {/* ) : (
                                <Button
                                  color="secondary"
                                  variant="contained"
                                  disabled={true}
                                >
                                  Save
                                </Button>
                              )} */}
                              {/* {YearFlag == "true" ? ( */}
                              <Button
                                disabled
                                color="error"
                                variant="contained"
                                onClick={() => {
                                  fnProcess(values, resetForm, "harddelete");
                                }}
                              >
                                Delete
                              </Button>
                              {/* ) : (
                                <Button
                                  color="error"
                                  variant="contained"
                                  disabled={true}
                                >
                                  Delete
                                </Button>
                              )} */}
                              <Button
                                type="reset"
                                color="warning"
                                variant="contained"
                                onClick={() => {
                                  setScreen(0);
                                }}
                              >
                                Cancel
                              </Button>
                            </Box>
                            <Popup
                              title="Process"
                              openPopup={openPROPopup}
                              setOpenPopup={setOpenPROPopup}
                            >
                              <Listviewpopup
                                accessID="2001"
                                screenName="Process"
                                childToParent={childToParent}
                              />
                            </Popup>
                          </form>
                        )}
                      </Formik>
                    </FormControl>
                  </Box>
                </form>
              )}
            </Formik>
            {/* </Box> */}
          </Paper>
        ) : (
          false
        )}
        {show == "2" ? (
          <Paper elevation={3} sx={{ margin: "10px" }}>
            {/* <Box m="10px"> */}
            <Formik
              initialValues={functionInitialValue}
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                setTimeout(() => {
                  empFunctionFn(values, resetForm, false);
                }, 100);
              }}
            >
              {({
                errors,
                touched,
                handleBlur,
                handleChange,
                isSubmitting,
                values,
                handleSubmit,
                resetForm,
                setFieldValue,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  onReset={() => {
                    selectCellRowData({ rowData: {}, mode: "A", field: "" });
                    resetForm();
                  }}
                >
                  <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 4",
                      },
                    }}
                  >
                    <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="code"
                        name="code"
                        value={values.code}
                        label="Model"
                        focused
                        inputProps={{ readOnly: true }}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="description"
                        name="description"
                        value={values.description}
                        label="Description"
                        focused
                        inputProps={{ readOnly: true }}
                      />
                    </FormControl>
                    {/* <Stack
                      sx={{
                        gridColumn: "span 2",
                        alignContent: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        right: "0px",
                      }}
                    >
                      <img
                        src={values.imageurl}
                        style={{ width: "200px", height: "150px" }}
                      />
                    </Stack> */}
                    {isNonMobile && (
                      <Stack
                        sx={{
                          //    width: {sm:'100%',md:'100%',lg:'100%'},
                          gridColumn: "span 2",
                          alignContent: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          right: "0px",
                        }}
                      >
                        <Avatar
                          variant="rounded"
                          src={userimg}
                          sx={{ width: "200px", height: "150px" }}
                        />
                      </Stack>
                    )}

                    <Box sx={{ gridColumn: "span 2" }}>
                      <Box
                        height="350px"
                        sx={{
                          "& .MuiDataGrid-root": {
                            // border: "none",
                          },
                          "& .MuiDataGrid-cell": {
                            // borderBottom: "none",
                          },
                          "& .name-column--cell": {
                            color: colors.greenAccent[300],
                          },
                          "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: colors.blueAccent[800],
                            // borderBottom: "none",
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            backgroundColor: colors.primary[400],
                          },
                          "& .MuiDataGrid-footerContainer": {
                            // borderTop: "none",
                            backgroundColor: colors.blueAccent[800],
                          },
                          "& .MuiCheckbox-root": {
                            color: `${colors.greenAccent[200]} !important`,
                          },
                          "& .odd-row": {
                            backgroundColor: "",
                            color: "", // Color for odd rows
                          },
                          "& .even-row": {
                            backgroundColor: "#d0edec",
                            color: "", // Color for even rows
                          },
                        }}
                      >
                        <DataGrid
                          sx={{
                            "& .MuiDataGrid-footerContainer": {
                              height: dataGridHeaderFooterHeight,
                              minHeight: dataGridHeaderFooterHeight,
                            },
                          }}
                          rowHeight={dataGridRowHeight}
                          headerHeight={dataGridHeaderFooterHeight}
                          // checkboxSelection
                          rows={explorelistViewData}
                          columns={columns}
                          disableSelectionOnClick
                          getRowId={(row) => row.RecordID}
                          pageSize={pageSize}
                          onPageSizeChange={(newPageSize) =>
                            setPageSize(newPageSize)
                          }
                          onCellClick={(params) => {
                            selectCellRowData({
                              rowData: params.row,
                              mode: "E",
                              field: params.field,
                            });
                          }}
                          rowsPerPageOptions={[5, 10, 20]}
                          pagination
                          components={{
                            Toolbar: Employee,
                          }}
                          onStateChange={(stateParams) =>
                            setRowCount(stateParams.pagination.rowCount)
                          }
                          loading={exploreLoading}
                          componentsProps={{
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                            },
                          }}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "odd-row"
                              : "even-row"
                          }
                        />
                      </Box>
                    </Box>
                    <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                      {/* <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <TextField
                          id="function"
                          label="Function"
                          variant="standard"
                          focused
                          required
                          inputProps={{ tabIndex: "-1" }}
                          value={functionLookup.funCode}
                        />
                        <IconButton
                          onClick={() => handleShow("FUN")}
                          sx={{ height: 40, width: 40 }}
                        >
                          <img src="https://img.icons8.com/color/48/null/details-popup.png" />
                        </IconButton>
                        <TextField
                          id="dies"
                          variant="standard"
                          fullWidth
                          inputProps={{ tabIndex: "-1" }}
                          focused
                          value={functionLookup.funName}
                        />
                      </Box> */}
                      <Productautocomplete
                        name="function"
                        label="Function"
                        id="function"
                        value={functionLookup}
                        // disabled
                        readOnly
                        onOpen={(e) => e.preventDefault()}
                        onChange={(newValue) => {
                          SetFunctionLookup({
                            RecordID: newValue.RecordID,
                            Code: newValue.Code,
                            Name: newValue.Name,
                          });
                        }}
                        // value={values.function}
                        // onChange={(newValue) =>{
                        //   setFieldValue("function",newValue)
                        // }}

                        url={`${listViewurl}?data={"Query":{"AccessID":"2048","ScreenName":"Functions","Filter":"","Any":""}}`}
                      />
                    </FormControl>
                  </Box>
                  <Box
                    display="flex"
                    padding={1}
                    justifyContent="end"
                    // mt="30px"
                    gap={2}
                  >
                    {/* {YearFlag == "true" ? ( */}
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={isLoading}
                      disabled
                    >
                      Save
                    </LoadingButton>
                    {/* ) : (
                      <Button
                        color="secondary"
                        variant="contained"
                        disabled={true}
                      >
                        Save
                      </Button>
                    )}
                    {YearFlag == "true" ? ( */}
                    <Button
                      onClick={() => empFunctionFn(values, resetForm, true)}
                      color="error"
                      variant="contained"
                      disabled
                    >
                      Delete
                    </Button>
                    {/* ) : (
                      <Button color="error" variant="contained" disabled={true}>
                        Delete
                      </Button>
                    )} */}
                    <Button
                      type="reset"
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        setScreen(0);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                  <Popup
                    title="Functions"
                    openPopup={openFunPopup}
                    setOpenPopup={setOpenFunPopup}
                  >
                    <Listviewpopup
                      accessID="2048"
                      screenName="Functions"
                      childToParent={childToParent}
                    />
                  </Popup>
                </form>
              )}
            </Formik>
            {/* </Box> */}
          </Paper>
        ) : (
          false
        )}

        {show == "3" ? (
          <Paper elevation={3} sx={{ margin: "10px" }}>
            {/* <Box m="10px"> */}
            <Formik
              initialValues={managerInitialValue}
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                setTimeout(() => {
                  mgrFunctionFn(values, resetForm, false);
                }, 100);
              }}
            >
              {({
                errors,
                touched,
                handleBlur,
                handleChange,
                isSubmitting,
                values,
                handleSubmit,
                resetForm,
                setFieldValue,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  onReset={() => {
                    selectCellRowData({ rowData: {}, mode: "A", field: "" });
                    resetForm();
                  }}
                >
                  <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 4",
                      },
                    }}
                  >
                    <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="code"
                        name="code"
                        value={values.code}
                        label="Model"
                        focused
                        inputProps={{ readOnly: true }}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="description"
                        name="description"
                        value={values.description}
                        label="Description"
                        focused
                        inputProps={{ readOnly: true }}
                      />
                    </FormControl>
                    {isNonMobile && (
                      <Stack
                        sx={{
                          //    width: {sm:'100%',md:'100%',lg:'100%'},
                          gridColumn: "span 2",
                          alignContent: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          right: "0px",
                        }}
                      >
                        <Avatar
                          variant="rounded"
                          src={userimg}
                          sx={{ width: "200px", height: "150px" }}
                        />
                      </Stack>
                    )}

                    {/* <Box sx={{ gridColumn: "span 2" }}>
                      <Box
                        height="350px"
                        sx={{
                          "& .MuiDataGrid-root": {
                            // border: "none",
                          },
                          "& .MuiDataGrid-cell": {
                            // borderBottom: "none",
                          },
                          "& .name-column--cell": {
                            color: colors.greenAccent[300],
                          },
                          "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: colors.blueAccent[800],
                            // borderBottom: "none",
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            backgroundColor: colors.primary[400],
                          },
                          "& .MuiDataGrid-footerContainer": {
                            // borderTop: "none",
                            backgroundColor: colors.blueAccent[800],
                          },
                          "& .MuiCheckbox-root": {
                            color: `${colors.greenAccent[200]} !important`,
                          },
                        }}
                      >
                        <DataGrid
                          // checkboxSelection
                          rows={explorelistViewData}
                          columns={columns}
                          disableSelectionOnClick
                          getRowId={(row) => row.RecordID}
                          pageSize={pageSize}
                          onPageSizeChange={(newPageSize) =>
                            setPageSize(newPageSize)
                          }
                          onCellClick={(params) => {
                            selectCellRowData({
                              rowData: params.row,
                              mode: "E",
                              field: params.field,
                            });
                          }}
                          rowsPerPageOptions={[5, 10, 20]}
                          pagination
                          components={{
                            Toolbar: Employee,
                          }}
                          onStateChange={(stateParams) =>
                            setRowCount(stateParams.pagination.rowCount)
                          }
                          loading={exploreLoading}
                          componentsProps={{
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                            },
                          }}
                        />
                      </Box>
                    </Box> */}

                    <FormControl sx={{ gridColumn: "span 4" }}>
                      <Formik
                      //initialValues={DetailinitialValues}
                      //validationSchema={countrySchema}
                      //enableReinitialize={ini}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleBlur,
                          handleChange,
                        }) => (
                          <Box>
                            <Box>
                              <Box
                                // m="5px 0 0 0"
                                height="350px"
                                // height="40vh"
                                sx={{
                                  "& .MuiDataGrid-root": {
                                    border: "none",
                                    width: "100%",
                                  },
                                  "& .MuiDataGrid-cell": {
                                    borderBottom: "none",
                                  },
                                  "& .name-column--cell": {
                                    color: colors.greenAccent[300],
                                  },
                                  "& .MuiDataGrid-columnHeaders": {
                                    backgroundColor: colors.blueAccent[800],
                                    borderBottom: "none",
                                  },
                                  "& .MuiDataGrid-virtualScroller": {
                                    backgroundColor: colors.primary[400],
                                  },
                                  "& .MuiDataGrid-footerContainer": {
                                    borderTop: "none",
                                    backgroundColor: colors.blueAccent[800],
                                  },
                                  "& .MuiCheckbox-root": {
                                    color: `${colors.greenAccent[200]} !important`,
                                  },
                                  "& .odd-row": {
                                    backgroundColor: "",
                                    color: "", // Color for odd rows
                                  },
                                  "& .even-row": {
                                    backgroundColor: "#d0edec",
                                    color: "", // Color for even rows
                                  },
                                }}
                              >
                                <DataGrid
                                  sx={{
                                    "& .MuiDataGrid-footerContainer": {
                                      height: dataGridHeaderFooterHeight,
                                      minHeight: dataGridHeaderFooterHeight,
                                    },
                                  }}
                                  // checkboxSelection
                                  rowHeight={dataGridRowHeight}
                                  headerHeight={dataGridHeaderFooterHeight}
                                  rows={explorelistViewData}
                                  columns={column}
                                  loading={exploreLoading}
                                  rowModesModel={rowModesModel}
                                  getRowId={(row) => row.RecordID}
                                  pageSize={pageSize}
                                  onPageSizeChange={(newPageSize) =>
                                    setPageSize(newPageSize)
                                  }
                                  editMode="row"
                                  disableRowSelectionOnClick
                                  experimentalFeatures={{ newEditingApi: true }}
                                  onRowModesModelChange={
                                    handleRowModesModelChange
                                  }
                                  processRowUpdate={processRowUpdate}
                                  // onProcessRowUpdateError={handleProcessRowUpdateError}
                                  components={{
                                    Toolbar: EditmanagerToolbar,
                                  }}
                                  componentsProps={{
                                    toolbar: { setRows, setRowModesModel },
                                  }}
                                  // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                  rowsPerPageOptions={[5, 10, 20]}
                                  pagination
                                  getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0
                                      ? "odd-row"
                                      : "even-row"
                                  }
                                />

                                {Object.keys(errorState).length > 0 && (
                                  <div style={{ color: "red" }}>
                                    {Object.entries(errorState).map(
                                      ([field, message]) => (
                                        <p
                                          key={field}
                                        >{`${field}: ${message}`}</p>
                                      )
                                    )}
                                  </div>
                                )}
                              </Box>
                              <Box
                                display="flex"
                                padding={1}
                                justifyContent="end"
                                mt="30px"
                                gap={2}
                              >
                                <Button
                                  disabled
                                  color="secondary"
                                  variant="contained"
                                  onClick={() => handleSaveButtonMangersClick()} // This will dynamically decide the action based on 'action' value
                                >
                                  Save
                                </Button>
                                <Button
                                  type="reset"
                                  color="warning"
                                  variant="contained"
                                  onClick={() => {
                                    setScreen(0);
                                  }}
                                >
                                  Cancel
                                </Button>
                              </Box>
                              {/* <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  width: "100%",
                                  marginTop: "20px",
                                }}
                              > */}
                              {/* <Button
                                  color="secondary"
                                  variant="contained"
                                  onClick={() => handleSaveButtonMangersClick()} // This will dynamically decide the action based on 'action' value
                                >
                                  Save
                                </Button> */}

                              {/* </Box> */}
                            </Box>
                          </Box>
                        )}
                      </Formik>
                    </FormControl>

                    {/* <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                    
                      <Productautocomplete
                          name="manager"
                          label="Manager"
                          id="manager"
                          // value={values.manager}
                          // onChange={(newValue) =>{
                          //   setFieldValue("manager",newValue)
                          // }}
                          value={designationLookup} 
                          onChange={(newValue) => {
                            SetDesignationLookup({
                              RecordID: newValue.RecordID,
                              Code: newValue.Code,
                              Name: newValue.Name,
                            })

                          }}
                          url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2047","ScreenName":"Designation","Filter":"","Any":""}}`}
              
                        />
                    </FormControl> */}
                  </Box>
                  {/* <Box display="flex" justifyContent="end" mt="30px" gap={2}>
                 
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={isLoading}
                    >
                      Save
                    </LoadingButton>
                   
                    <Button
                      onClick={() => mgrFunctionFn(values, resetForm, true)}
                      color="error"
                      variant="contained"
                    >
                      Delete
                    </Button>
                    
                    <Button type="reset" color="warning" variant="contained">
                      Cancel
                    </Button>
                  </Box> */}
                  <Popup
                    title="Functions"
                    openPopup={openFunPopup}
                    setOpenPopup={setOpenFunPopup}
                  >
                    <Listviewpopup
                      accessID="2048"
                      screenName="Functions"
                      childToParent={childToParent}
                    />
                  </Popup>
                  <Popup
                    title="Designations"
                    openPopup={openDesPopup}
                    setOpenPopup={setOpenDesPopup}
                  >
                    <Listviewpopup
                      accessID="2049"
                      screenName="Designations"
                      childToParent={childToParent}
                      filterName={"Rank"}
                      filterValue={Data.Rank}
                    />
                  </Popup>
                </form>
              )}
            </Formik>
            {/* </Box> */}
          </Paper>
        ) : (
          false
        )}
        {show == "4" ? (
          <Paper elevation={3} sx={{ margin: "10px" }}>
            {/* <Box m="10px"> */}
            <Formik
              initialValues={deploymentInitialValue}
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                setTimeout(() => {
                  Fndeployment(values, resetForm, false);
                }, 100);
              }}
            >
              {({
                errors,
                touched,
                handleBlur,
                handleChange,
                isSubmitting,
                values,
                handleSubmit,
                resetForm,
                setFieldValue,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  onReset={() => {
                    selectCellRowData({ rowData: {}, mode: "A", field: "" });
                    resetForm();
                  }}
                >
                  <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 4",
                      },
                    }}
                  >
                    <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="code"
                        name="code"
                        value={values.code}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Model"
                        focused
                        inputProps={{ readOnly: true }}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="description"
                        name="description"
                        value={values.description}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Description"
                        focused
                        inputProps={{ readOnly: true }}
                      />
                    </FormControl>

                    {/* <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="checkin"
                        name="checkin"
                        value={values.checkin}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Checkin"
                        focused
                        // inputProps={{ maxLength:20}}
                      />
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="checkout"
                        name="checkout"
                        value={values.checkout}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Checkout"
                        focused
                        // inputProps={{ readOnly: true }}
                      /> */}
                    {/* <TextField
                        fullWidth
                        variant="standard"
                        label="Checkin"
                        type="text"
                        id="checkin"
                        name="checkin"
                        value={values.checkin}
                      /> */}

                    <Stack
                      sx={{
                        gridColumn: "span 2",
                        alignContent: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        right: "0px",
                      }}
                    >
                      <Avatar
                        variant="rounded"
                        src={userimg}
                        sx={{ width: "200px", height: "120px" }}
                      />
                    </Stack>
                    {/* <FormControl
                      sx={{
                        gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <TextField
                        id="outlined-basic"
                        label="ID"
                        variant="standard"
                        value={designLookup.designlookupRecordid}
                        focused
                        sx={{ display: "none" }}
                      />
                      <TextField
                        id="outlined-basic"
                        label="Designation"
                        variant="standard"
                        value={designLookup.designlookupCode}
                        focused
                        required
                        DESIGN
                        inputProps={{ tabIndex: "-1" }}
                      />
                     
                      <IconButton
                        sx={{ height: 40, width: 40 }}
                        onClick={() => handleShow("DESIGN")}
                      >
                        <img src="https://img.icons8.com/color/48/null/details-popup.png" />
                      </IconButton>
                      <TextField
                        id="outlined-basic"
                        label=""
                        variant="standard"
                        value={designLookup.designlookupDesc}
                        fullWidth
                        focused
                        inputProps={{ tabIndex: "-1" }}
                      />
                    </FormControl> */}
                    <FormControl
                    inputProps={{ readOnly: true }}
                      sx={{
                        gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        
                      }}
                    >
                      <Productautocomplete
                        name="manager"
                        label="Designation"
                        id="manager"
                        value={values.manager}
                        // disabled
                         readOnly
                         onOpen={(e) => e.preventDefault()}
                        // inputProps={{ readOnly: true }}
                        onChange={(newValue) => {
                          setFieldValue("manager", newValue);
                        }}
                        //value={selectedProjectOptions}
                        //onChange={handleSelectionProjectname}
                        // defaultValue={selectedProjectName}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2047","ScreenName":"Designation","Filter":"parentID=${compID}","Any":""}}`}
                      />
                    </FormControl>

                    <FormControl
                      sx={{
                        gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Productautocomplete
                        name="location"
                        label="Location"
                        id="location"
                        value={values.location}
                        readOnly
                        onOpen={(e) => e.preventDefault()}
                        // disabled
                        onChange={(newValue) => {
                          setFieldValue("location", newValue);
                        }}
                        //  onChange={handleSelectionFunctionname}
                        // defaultValue={selectedFunctionName}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2051","ScreenName":"Location","Filter":"parentID=${compID}","Any":""}}`}
                      />
                    </FormControl>
                    {/* <FormControl
                      sx={{
                        gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <TextField
                        id="outlined-basic"
                        label="ID"
                        variant="standard"
                        value={locationLookup.locationRecordID}
                        focused
                        sx={{ display: "none" }}
                      />
                      <TextField
                        id="outlined-basic"
                        label="Location"
                        variant="standard"
                        value={locationLookup.locationCode}
                        focused
                        required
                        DESIGN
                        inputProps={{ tabIndex: "-1" }}
                      />
                    
                      <IconButton
                        sx={{ height: 40, width: 40 }}
                        onClick={() => handleShow("LOCATION")}
                      >
                        <img src="https://img.icons8.com/color/48/null/details-popup.png" />
                      </IconButton>
                      <TextField
                        id="outlined-basic"
                        label=""
                        variant="standard"
                        value={locationLookup.locationName}
                        fullWidth
                        focused
                        inputProps={{ tabIndex: "-1" }}
                      />
                    </FormControl> */}
                    {/* <FormControl
                      sx={{
                        gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <TextField
                        id="outlined-basic"
                        label="ID"
                        variant="standard"
                        value={gateLookup.gateRecordID}
                        focused
                        sx={{ display: "none" }}
                      />
                      <TextField
                        id="outlined-basic"
                        label="Gate"
                        variant="standard"
                        value={gateLookup.gateCode}
                        focused
                        required
                        DESIGN
                        inputProps={{ tabIndex: "-1" }}
                      />
                     
                      <IconButton
                        sx={{ height: 40, width: 40 }}
                        onClick={() => handleShow("GATE")}
                      >
                        <img src="https://img.icons8.com/color/48/null/details-popup.png" />
                      </IconButton>
                      <TextField
                        id="outlined-basic"
                        label=""
                        variant="standard"
                        value={gateLookup.gateName}
                        fullWidth
                        focused
                        inputProps={{ tabIndex: "-1" }}
                      />
                    </FormControl> */}
                    <FormControl
                      sx={{
                        gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Productautocomplete
                        name="gate"
                        label={
                          <span>
                            Gate
                            <span style={{ color: "red", fontWeight: "bold" }}>
                              *
                            </span>
                          </span>
                        }
                        variant="outlined"
                        id="gate"
                        // value={gateLookup}
                        value={values.gate}
                        // disabled
                        readOnly
                        onOpen={(e) => e.preventDefault()}
                        onChange={(newValue) => {
                          setFieldValue("gate", newValue);
                          console.log(newValue, "--newvalue gate");
                          console.log(newValue.RecordID, "gate RecordID");

                          // SetGateLookup({
                          //   RecordID: newValue.RecordID,
                          //   Code: newValue.Code,
                          //   Name: newValue.Name,
                          // });
                        }}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2050","ScreenName":"Gate","Filter":"parentID='${
                          values.location ? values.location.RecordID : 0
                        }'","Any":""}}`}
                      />
                    </FormControl>
                    <FormControl
                      sx={{
                        gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Productautocomplete
                        id="function"
                        name="function"
                        label={
                          <span>
                            Function
                            <span style={{ color: "red", fontWeight: "bold" }}>
                              *
                            </span>
                          </span>
                        }
                        variant="outlined"
                        // disabled
                        readOnly
                        onOpen={(e) => e.preventDefault()}
                        value={values.function}
                        onChange={(newValue) => {
                          setFieldValue("function", newValue);
                          console.log(newValue, "--newvalue function");
                          console.log(newValue.RecordID, "function RecordID");
                        }}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2048","ScreenName":"Function","Filter":"CompanyID
 ='${compID}'","Any":""}}`}
                      />
                    </FormControl>
                    <FormControl
                      sx={{
                        gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Productautocomplete
                        id="project"
                        name="project"
                        label={
                          <span>
                            Project
                            <span style={{ color: "red", fontWeight: "bold" }}>
                              *
                            </span>
                          </span>
                        }
                        variant="outlined"
                        // disabled
                        readOnly
                        onOpen={(e) => e.preventDefault()}
                        value={values.project}
                        onChange={(newValue) => {
                          setFieldValue("project", newValue);
                          console.log(newValue, "--newvalue project");
                          console.log(newValue.RecordID, "project RecordID");
                        }}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2054","ScreenName":"Project","Filter":"parentID='${compID}'","Any":""}}`}
                      />
                    </FormControl>

                    {/* <FormControl
                      sx={{
                        gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <TextField
                        id="outlined-basic"
                        label="ID"
                        variant="standard"
                        value={checkInLookup.cinRecordID}
                        focused
                        sx={{ display: "none" }}
                      />
                      <TextField
                        id="outlined-basic"
                        label="CheckIn"
                        variant="standard"
                        value={checkInLookup.cinCode}
                        focused
                        required
                        DESIGN
                        inputProps={{ tabIndex: "-1" }}
                      />

                      <IconButton
                        sx={{ height: 40, width: 40 }}
                        onClick={() => handleShow("CIN")}
                      >
                        <img src="https://img.icons8.com/color/48/null/details-popup.png" />
                      </IconButton>
                      <TextField
                        id="outlined-basic"
                        label="CheckIn"
                        variant="standard"
                        value={checkInLookup.cinName}
                        fullWidth
                        focused
                        inputProps={{ tabIndex: "-1" }}
                      />
                    </FormControl> */}
                  </Box>
                  <Divider variant="fullWidth" sx={{ mt: "20px" }} />
                  <Typography
                  padding={1}
                  variant="h5">Shift Details</Typography>
                  <Stack
                    direction="column"
                    spacing={2}
                    sx={{ width: 500,padding: formGap }}
                  >
                    {/* Shift */}
                    <FormControl variant="standard" fullWidth>
                      {/* <TextField
    select // 👈 This is required for dropdown
    fullWidth
    type="text"
    id="checkin"
    name="checkin"
    value={values.checkin}
    onBlur={handleBlur}
    onChange={handleChange}
    label="Shift"
    focused
  >
    <MenuItem value="HS">General</MenuItem>
    <MenuItem value="DS">Days</MenuItem>
    <MenuItem value="WS">Week</MenuItem>
    <MenuItem value="MS">Month</MenuItem>
  </TextField> */}
                      <Productautocomplete
                        id="shift"
                        name="shift"
                        label={
                          <span>
                            Shift
                            <span style={{ color: "red", fontWeight: "bold" }}>
                              *
                            </span>
                          </span>
                        }
                        variant="outlined"
                        value={values.shift}
                        // disabled
                        readOnly

                        onChange={(newValue) => {
                          //                        Monday: deploymentData.Monday === "Y" ? true : false,
                          // Tuesday: deploymentData.TuesdayTuesdayShift === "Y" ? true : false,
                          // Wednesday: deploymentData.Wednesday === "Y" ? true : false,
                          // Thursday: deploymentData.Thursday === "Y" ? true : false,
                          // Friday: deploymentData.Friday === "Y" ? true : false,
                          // Saturday: deploymentData.Saturday === "Y" ? true : false,
                          // Sunday: deploymentData.Sunday === "Y" ? true : false,
                          setFieldValue("shift", newValue);
                          setFieldValue(
                            "Monday",
                            newValue.Monday === "Y" ? true : false
                          );
                          setFieldValue(
                            "Tuesday",
                            newValue.Tuesday === "Y" ? true : false
                          );
                          setFieldValue(
                            "Wednesday",
                            newValue.Wednesday === "Y" ? true : false
                          );
                          setFieldValue(
                            "Thursday",
                            newValue.Thursday === "Y" ? true : false
                          );
                          setFieldValue(
                            "Friday",
                            newValue.Friday === "Y" ? true : false
                          );
                          setFieldValue(
                            "Saturday",
                            newValue.Saturday === "Y" ? true : false
                          );
                          setFieldValue(
                            "Sunday",
                            newValue.Sunday === "Y" ? true : false
                          );
                          console.log(newValue, "--newvalue shift");
                          console.log(newValue.RecordID, "shift RecordID");
                        }}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2108","ScreenName":"Shift","Filter":"","Any":""}}`}
                      />
                    </FormControl>

                    {/* Check In Time */}
                    <FormControl variant="standard">
                      <TextField
                        fullWidth
                        type="time"
                        id="checkin"
                        name="checkin"
                        value={values.shift?.ShiftStartTime || values.checkin}
                        // value={values.checkin}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Shift Start Time"
                        focused
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </FormControl>

                    {/* Check Out Time */}
                    <FormControl variant="standard">
                      <TextField
                        fullWidth
                        type="time"
                        id="checkout"
                        name="checkout"
                        value={values.shift?.ShiftendTime || values.checkout}
                        // value={values.checkout}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Shift End Time"
                        focused
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </FormControl>
                  </Stack>

                  <Divider variant="fullWidth" sx={{ mt: "20px" }} />
                  <Typography variant="h5"
                   padding={1}
                  >Week Off</Typography>
                  <Box>
                    <Field
                      //  size="small"
                      type="checkbox"
                      name="Monday"
                      id="Monday"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      as={Checkbox}
                      label="Monday"
                      disabled
                    />

                    <FormLabel focused={false}>Monday</FormLabel>

                    <Field
                      //  size="small"
                      type="checkbox"
                      name="Tuesday"
                      id="Tuesday"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      as={Checkbox}
                      label="Tuesday"
                      disabled
                    />

                    <FormLabel focused={false}>Tuesday</FormLabel>

                    <Field
                      //  size="small"
                      type="checkbox"
                      name="Wednesday"
                      id="Wednesday"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      as={Checkbox}
                      label="Wednesday"
                      disabled
                    />

                    <FormLabel focused={false}>Wednesday</FormLabel>

                    <Field
                      //  size="small"
                      type="checkbox"
                      name="Thursday"
                      id="Thursday"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      as={Checkbox}
                      label="Thursday"
                      disabled
                    />

                    <FormLabel focused={false}>Thursday</FormLabel>

                    <Field
                      //  size="small"
                      type="checkbox"
                      name="Friday"
                      id="Friday"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      as={Checkbox}
                      label="Friday"
                      disabled
                    />

                    <FormLabel focused={false}>Friday</FormLabel>

                    <Field
                      //  size="small"
                      type="checkbox"
                      name="Saturday"
                      id="Saturday"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      as={Checkbox}
                      label="Saturday"
                      disabled
                    />

                    <FormLabel focused={false}>Saturday</FormLabel>

                    <Field
                      //  size="small"
                      type="checkbox"
                      name="Sunday"
                      id="Sunday"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      as={Checkbox}
                      label="Sunday"
                      disabled
                    />

                    <FormLabel focused={false}>Sunday</FormLabel>
                  </Box>
                  <Divider variant="fullWidth" sx={{ mt: "20px" }} />
                  <Typography variant="h5" padding={1}
                  >
                    Checkin & Checkout Options
                  </Typography>
                  <Box>
                    <Field
                      //  size="small"
                      type="checkbox"
                      name="biometric"
                      id="biometric"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      as={Checkbox}
                      label="biometric"
                      disabled
                    />

                    <FormLabel focused={false}>Biometric</FormLabel>

                    <Field
                      //  size="small"
                      type="checkbox"
                      name="mobile"
                      id="mobile"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      as={Checkbox}
                      label="mobile"
                      disabled
                    />

                    <FormLabel focused={false}>Mobile Geofencing</FormLabel>

                    <Field
                      //  size="small"
                      type="checkbox"
                      name="cloud"
                      id="cloud"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      as={Checkbox}
                      label="cloud"
                      disabled
                    />

                    <FormLabel focused={false}>Cloud Application</FormLabel>

                    <Field
                      //  size="small"
                      type="checkbox"
                      name="managermanual"
                      id="managermanual"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      as={Checkbox}
                      label="managermanual"
                      disabled
                    />

                    <FormLabel focused={false}>Manager Manual</FormLabel>
                  </Box>
                  <Box
                    display="flex"
                    padding={1}
                    justifyContent="end"
                    mt="30px"
                    gap={2}
                  >
                    {/* {YearFlag == "true" ? ( */}
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={isLoading}
                      disabled
                    >
                      Save
                    </LoadingButton>
                    {/* ) : (
                      <Button
                        color="secondary"
                        variant="contained"
                        disabled={true}
                      >
                        Save
                      </Button>
                    )} */}
                    {/* {YearFlag == "true" ? (
                      <Button
                        onClick={() => mgrFunctionFn(values, resetForm, true)}
                        color="error"
                        variant="contained"
                      >
                        Delete
                      </Button>
                    ) : (
                      <Button color="error" variant="contained" disabled={true}>
                        Delete
                      </Button>
                    )} */}
                    <Button
                      type="reset"
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        setScreen(0);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>

                  <Popup
                    title="Location"
                    openPopup={openLOCATIONPopup}
                    setOpenPopup={setOpenLOCATIONPopup}
                  >
                    <Listviewpopup
                      accessID="2051"
                      screenName="Location"
                      childToParent={childToParent}
                    />
                  </Popup>
                  <Popup
                    title="Gate"
                    openPopup={openGATEPopup}
                    setOpenPopup={setOpenGATEPopup}
                  >
                    <Listviewpopup
                      accessID="2050"
                      screenName="Gate"
                      childToParent={childToParent}
                    />
                  </Popup>
                  <Popup
                    title="Designation"
                    openPopup={opendesignPopup}
                    setOpenPopup={setOpendesignPopup}
                  >
                    <Listviewpopup
                      accessID="2047"
                      screenName="Designation"
                      childToParent={childToParent}
                    />
                  </Popup>
                  {/* <Popup
                    title="CheckIn"
                    openPopup={openCHECKINPopup}
                    setOpenPopup={setOpenCHECKINPopup}
                  >
                    <Listviewpopup
                      accessID=""
                      screenName="CheckIn"
                      childToParent={childToParent}
                    />
                  </Popup> */}
                </form>
              )}
            </Formik>

            {/* </Box> */}
          </Paper>
        ) : (
          false
        )}
  {show == "10" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
            <Formik
              initialValues={resignationinitialvalues}
              enableReinitialize={true}
              // validationSchema={validationSchema2}
              onSubmit={(values, { resetForm }) => {
                setTimeout(() => {
                  Fnsaveresignation(values, resetForm, false);
                }, 100);
              }}
            >
              {({
                errors,
                touched,
                handleBlur,
                handleChange,
                isSubmitting,
                values,
                handleSubmit,
                resetForm,
                setFieldValue,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  onReset={() => {
                    selectCellRowData({ rowData: {}, mode: "A", field: "" });
                    resetForm();
                  }}
                >
                  <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                    // gap="30px"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 2",
                      },
                    }}
                  >
                    <FormControl sx={{ gap: formGap }}>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="code"
                        name="code"
                        value={values.code}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Code"
                        sx={{
                          gridColumn: "span 2",
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                          },
                        }}
                        focused
                      inputProps={{ readOnly: true }}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="description"
                        name="description"
                        value={values.description}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Name"
                        sx={{
                          //gridColumn: "span 2",
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                          },
                        }}
                        focused
                      inputProps={{ readOnly: true }}
                      />
                     
                    </FormControl>
                    <Stack
                      sx={{
                        //gridColumn: "span 2",
                        alignContent: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        right: "0px",
                      }}
                    >
                      <Avatar
                        variant="rounded"
                        src={userimg}
                        sx={{ width: "200px", height: "120px" }}
                      />
                    </Stack>
                         <Box sx={{ width: "100%" }}>
                      <FormControl
                       inputProps={{ readOnly: true }}
                        sx={{
                          //gridColumn: "span 2",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                          <TextField
                          name="resignationdate"
                          type="date"
                          id="resignationdate"
                          label="Resignation Date"
                        fullWidth
                        variant="standard"
                        inputFormat="YYYY-MM-DD"
                        value={values.resignationdate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.resignationdate && !!errors.resignationdate}
                        helperText={touched.resignationdate && errors.resignationdate}
                        // sx={{

                        //   backgroundColor: "#ffffff", // Set the background to white
                        //   "& .MuiFilledInput-root": {
                        //     backgroundColor: "", // Ensure the filled variant also has a white background
                        //   }
                        // }}
                        focused
                        inputProps={{ maxLength: 90,readOnly: true }}

                      />
                        {/* <CheckinAutocomplete
                          name="location"
                          label={
                            <span>
                              Location
                              <span style={{ color: "red", fontSize: "20px" }}>
                                *
                              </span>
                            </span>
                          }
                          variant="outlined"
                          id="location"
                          // value={locationLookup}
                          value={values.location}
                          onChange={(newValue) => {
                            setFieldValue("location", newValue);
                            // SetLocationLookup({
                            //   RecordID: newValue.RecordID,
                            //   Code: newValue.Code,
                            //   Name: newValue.Name,
                            // });
                          }}
                          error={!!touched.location && !!errors.location}
                          helperText={touched.location && errors.location}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2051","ScreenName":"Location","Filter":"parentID='${CompanyID}'","Any":""}}`}
                        /> */}
                      </FormControl>
                    </Box>
                    <Box sx={{ width: "100%" }}>
                      <FormControl
                       
                        sx={{
                          //gridColumn: "span 2",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                          <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        label="Resignation Note"
                        value={values.resignationnote}
                        id="resignationnote"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="resignationnote"
                        error={!!touched.resignationnote && !!errors.resignationnote}
                        helperText={touched.resignationnote && errors.resignationnote}
                        focused
                        inputProps={{ maxLength: 90,readOnly: true }}
                        multiline
                      // rows={2}
                      />
                        {/* <CheckinAutocomplete
                          name="location"
                          label={
                            <span>
                              Location
                              <span style={{ color: "red", fontSize: "20px" }}>
                                *
                              </span>
                            </span>
                          }
                          variant="outlined"
                          id="location"
                          // value={locationLookup}
                          value={values.location}
                          onChange={(newValue) => {
                            setFieldValue("location", newValue);
                            // SetLocationLookup({
                            //   RecordID: newValue.RecordID,
                            //   Code: newValue.Code,
                            //   Name: newValue.Name,
                            // });
                          }}
                          error={!!touched.location && !!errors.location}
                          helperText={touched.location && errors.location}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2051","ScreenName":"Location","Filter":"parentID='${CompanyID}'","Any":""}}`}
                        /> */}
                      </FormControl>
                    </Box>

                    <FormControl
                    inputProps={{ readOnly: true }}
                      sx={{
                        //gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Productautocomplete
                        name="exitinterviewby"
                        label={
                          <span>
                           Exit Interview By
                            <span style={{ color: "red", fontSize: "20px" }}>
                              *
                            </span>
                          </span>
                        }
                        variant="outlined"
                        id="exitinterviewby"
                        // value={exitinterviewbyLookup}
                        value={values.exitinterviewby}
                         readOnly
                          onOpen={(e) => e.preventDefault()}
                        onChange={(newValue) => {
                          setFieldValue("exitinterviewby", newValue);
                          console.log(newValue, "--newvalue exitinterviewby");
                          console.log(newValue.RecordID, "exitinterviewby RecordID");

                          // SetGateLookup({
                          //   RecordID: newValue.RecordID,
                          //   Code: newValue.Code,
                          //   Name: newValue.Name,
                          // });
                        }}
                        error={!!touched.exitinterviewby && !!errors.exitinterviewby}
                        helperText={touched.exitinterviewby && errors.exitinterviewby}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2165","ScreenName":"Exit Interview By","Filter":"CompanyID='${compID}'","Any":""}}`}
                      />
                    </FormControl>

                    <FormControl
                      sx={{
                        //gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                        <TextField
                          name="exitinterviewdate"
                          type="date"
                          id="exitinterviewdate"
                          label="Exit Interview Date"
                        fullWidth
                        variant="standard"
                        inputFormat="YYYY-MM-DD"
                        value={values.exitinterviewdate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.exitinterviewdate && !!errors.exitinterviewdate}
                        helperText={touched.exitinterviewdate && errors.exitinterviewdate}
                        // sx={{

                        //   backgroundColor: "#ffffff", // Set the background to white
                        //   "& .MuiFilledInput-root": {
                        //     backgroundColor: "", // Ensure the filled variant also has a white background
                        //   }
                        // }}
                        focused
                        inputProps={{ maxLength: 90,readOnly: true }}

                      />

                      {/* <CheckinAutocomplete
                        id="function"
                        name="function"
                        label="Function"
                        // label={
                        //   <span>
                        //     Function
                        //     <span style={{ color: "red", fontSize: "20px" }}>
                        //       *
                        //     </span>
                        //   </span>
                        // }
                        variant="outlined"
                        value={values.function}
                        onChange={(newValue) => {
                          setFieldValue("function", newValue);
                          console.log(newValue, "--newvalue function");
                          console.log(newValue.RecordID, "function RecordID");
                        }}
                        // error={!!touched.function && !!errors.function}
                        // helperText={touched.function && errors.function}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2048","ScreenName":"Function","Filter":"CompanyID
 ='${CompanyID}'","Any":""}}`}
                      /> */}
                    </FormControl>

                     

                    <FormControl
                      sx={{
                        //gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                          <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        label="Exit Interview Comments"
                        value={values.exitinterviewcomments}
                        id="exitinterviewcomments"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="exitinterviewcomments"
                        error={!!touched.exitinterviewcomments && !!errors.exitinterviewcomments}
                        helperText={touched.exitinterviewcomments && errors.exitinterviewcomments}
                        focused
                        inputProps={{ maxLength: 90,readOnly: true }}
                        multiline
                      // rows={2}
                      />
                      </FormControl>



                        <FormControl
                      sx={{
                        //gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                        <TextField
                          name="acceptedrelievingdate"
                          type="date"
                          id="acceptedrelievingdate"
                          label="Accepted Relieving Date"
                        fullWidth
                        variant="standard"
                        inputFormat="YYYY-MM-DD"
                        value={values.acceptedrelievingdate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.acceptedrelievingdate && !!errors.acceptedrelievingdate}
                        helperText={touched.acceptedrelievingdate && errors.acceptedrelievingdate}
                        focused
                        inputProps={{ maxLength: 90, readOnly: true }}

                      />

                    </FormControl>
                     <FormControl
                      sx={{
                        //gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                        <TextField
                          name="actualrelievingdate"
                          type="date"
                          id="actualrelievingdate"
                          label="Actual Relieving Date"
                        fullWidth
                        variant="standard"
                        inputFormat="YYYY-MM-DD"
                        value={values.actualrelievingdate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.actualrelievingdate && !!errors.actualrelievingdate}
                        helperText={touched.actualrelievingdate && errors.actualrelievingdate}
                        focused
                        inputProps={{ maxLength: 90, readOnly: true }}

                      />

                    </FormControl>
                     <FormControl
                      sx={{
                        //gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                        <TextField
                          name="dateofsettlement"
                          type="date"
                          id="dateofsettlement"
                          label="Date Of Settlement"
                        fullWidth
                        variant="standard"
                        inputFormat="YYYY-MM-DD"
                        value={values.dateofsettlement}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.dateofsettlement && !!errors.dateofsettlement}
                        helperText={touched.dateofsettlement && errors.dateofsettlement}
                        focused
                        inputProps={{ maxLength: 90, readOnly: true }}

                      />

                    </FormControl>
                     <Box>
                      <Field
                        //  size="small"
                        type="checkbox"
                        name="exitformalitiesacceptrd"
                        id="exitformalitiesacceptrd"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        as={Checkbox}
                        label="exitformalitiesacceptrd"
                      disabled
                      />

                      <FormLabel focused={false}>
                        Exit Formalities Accepted
                      </FormLabel>
                           </Box>
                  </Box>
                
                  <Box
                    display="flex"
                    justifyContent="end"
                    mt="30px"
                    padding={1}
                    gap={2}
                  >
                    <Button
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={isLoading}
                    >
                      Save
                    </Button>
                    {/* {YearFlag == "true" ? (
                      
                    ) : (
                      <Button
                        color="secondary"
                        variant="contained"
                        disabled={true}
                      >
                        Save
                      </Button>
                    )} */}

                    <Button
                      type="reset"
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        setScreen(0);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>

                  <Popup
                    title="Location"
                    openPopup={openLOCATIONPopup}
                    setOpenPopup={setOpenLOCATIONPopup}
                  >
                    <Listviewpopup
                      accessID="2051"
                      screenName="Location"
                      childToParent={childToParent}
                      filterName={"parentID"}
                      filterValue={compID}
                    />
                  </Popup>
                  <Popup
                    title="Gate"
                    openPopup={openGATEPopup}
                    setOpenPopup={setOpenGATEPopup}
                  >
                    <Listviewpopup
                      accessID="2050"
                      screenName="Gate"
                      filterName={"parentID"}
                      // filterValue={locationLookup.locationRecordID}
                      childToParent={childToParent}
                    />
                  </Popup>
                  <Popup
                    title="Designation"
                    openPopup={opendesignPopup}
                    setOpenPopup={setOpendesignPopup}
                  >
                    <Listviewpopup
                      accessID="2047"
                      screenName="Designation"
                      childToParent={childToParent}
                      filterName={"parentID"}
                      filterValue={compID}
                    />
                  </Popup>
                  {/* <Popup
                    title="CheckIn"
                    openPopup={openCHECKINPopup}
                    setOpenPopup={setOpenCHECKINPopup}
                  >
                    <Listviewpopup
                      accessID=""
                      screenName="CheckIn"
                      childToParent={childToParent}
                    />
                  </Popup> */}
                </form>
              )}
            </Formik>
          </Paper>
        ) : (
          false
        )}
        
        {show == "6" ? (
          <Paper elevation={3} sx={{ margin: "10px" }}>
            {/* <Box m="20px" sx={{ m: 2 }}> */}
            <Formik
              // onSubmit={handleFormSubmit}
              initialValues={AttachmentInitialValues}
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                setTimeout(() => {
                  FnAttachment(values, resetForm, false);
                }, 100);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleBlur,
                handleSubmit,
                handleChange,
                resetForm,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  onReset={() => {
                    selectCellRowData({ rowData: {}, mode: "A", field: "" });
                    resetForm();
                  }}
                >
                  <Box>
                    <Box
                      display="grid"
                      gap={formGap}
                      padding={1}
                      gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                      sx={{
                        "& > div": {
                          gridColumn: isNonMobile ? undefined : "span 4",
                        },
                      }}
                    >
                      <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                        <TextField
                          fullWidth
                          variant="standard"
                          type="text"
                          id="code"
                          name="code"
                          value={values.code}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          label="Model"
                          focused
                          inputProps={{ readOnly: true }}
                        />

                        <TextField
                          fullWidth
                          variant="standard"
                          type="text"
                          id="Name"
                          name="Name"
                          value={values.description}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          label="Name"
                          focused
                          inputProps={{ readOnly: true }}
                        />
                      </FormControl>
                      {isNonMobile && (
                        <Stack
                          sx={{
                            //    width: {sm:'100%',md:'100%',lg:'100%'},
                            gridColumn: "span 2",
                            alignContent: "center",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            right: "0px",
                          }}
                        >
                          <Avatar
                            variant="rounded"
                            src={userimg}
                            sx={{ width: "200px", height: "150px" }}
                          />
                        </Stack>
                      )}

                      <Box sx={{ gridColumn: "span 2" }}>
                        <Box
                          m="5px 0 0 0"
                          //  height={dataGridHeight}
                          height="350px"
                          sx={{
                            "& .MuiDataGrid-root": {
                              // border: "none",
                            },
                            "& .MuiDataGrid-cell": {
                              // borderBottom: "none",
                            },
                            "& .name-column--cell": {
                              color: colors.greenAccent[300],
                            },
                            "& .MuiDataGrid-columnHeaders": {
                              backgroundColor: colors.blueAccent[800],
                              // borderBottom: "none",
                            },
                            "& .MuiDataGrid-virtualScroller": {
                              backgroundColor: colors.primary[400],
                            },
                            "& .MuiDataGrid-footerContainer": {
                              // borderTop: "none",
                              backgroundColor: colors.blueAccent[800],
                            },
                            "& .MuiCheckbox-root": {
                              color: `${colors.greenAccent[200]} !important`,
                            },
                            "& .odd-row": {
                              backgroundColor: "",
                              color: "", // Color for odd rows
                            },
                            "& .even-row": {
                              backgroundColor: "#d0edec",
                              color: "", // Color for even rows
                            },
                          }}
                        >
                          <DataGrid
                            sx={{
                              "& .MuiDataGrid-footerContainer": {
                                height: dataGridHeaderFooterHeight,
                                minHeight: dataGridHeaderFooterHeight,
                              },
                            }}
                            // checkboxSelection
                            rowHeight={dataGridRowHeight}
                            headerHeight={dataGridHeaderFooterHeight}
                            rows={explorelistViewData}
                            columns={columns}
                            disableSelectionOnClick
                            getRowId={(row) => row.RecordID}
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) =>
                              setPageSize(newPageSize)
                            }
                            onCellClick={(params) => {
                              selectCellRowData({
                                rowData: params.row,
                                mode: "E",
                                field: params.field,
                              });
                            }}
                            rowsPerPageOptions={[5, 10, 20]}
                            pagination
                            components={{
                              Toolbar: Employee,
                            }}
                            onStateChange={(stateParams) =>
                              setRowCount(stateParams.pagination.rowCount)
                            }
                            loading={exploreLoading}
                            componentsProps={{
                              toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 },
                              },
                            }}
                            getRowClassName={(params) =>
                              params.indexRelativeToCurrentPage % 2 === 0
                                ? "odd-row"
                                : "even-row"
                            }
                          />
                        </Box>
                      </Box>
                      {/* </FormControl> */}

                      {/* <FormControl
                        sx={{
                          gridColumn: "span 2",
                          gap: formGap,
                          mt: { xs: "opx", md: "210px" },
                        }}
                      > */}
                      <FormControl
                        sx={{ gridColumn: "span 2", gap: formGap }}
                        style={{ width: "100%" }}
                      >
                        <TextField
                          fullWidth
                          variant="standard"
                          type="text"
                          id="LoaDescription"
                          name="LoaDescription"
                          value={values.LoaDescription}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          label="Description"
                          focused
                          inputProps={{ tabIndex: "-1", readOnly: true }}
                        />

                        <FormControl
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box>
                            <Typography variant="h6">
                              Certificate Attachment
                            </Typography>

                            <IconButton
                              size="large"
                              color="warning"
                              aria-label="upload picture"
                              component="label"
                            >
                              <input
                                hidden
                                accept="all/*"
                                type="file"
                                onChange={getFileChange}
                                disabled
                              />
                              <PictureAsPdfOutlinedIcon />
                            </IconButton>
                            <Button
                              variant="contained"
                              component={"a"}
                              // onClick={() => {
                              //   ImageName
                              //     ? 
                              //     window.open(
                              //                                       `${baseurl1}uploads/images/${ImageName}`,
                              //                                       "_blank",
                              //                                     )
                              //     // window.open(
                              //     //     ImageName
                              //     //       ? store.getState().globalurl
                              //     //           .attachmentUrl + ImageName
                              //     //       : store.getState().globalurl
                              //     //           .attachmentUrl + Data.ImageName,
                              //     //     "_blank"
                              //     //   )
                              //     : toast.error("Please Upload File");
                              // }}

                               onClick={() => {
    if (ImageName) {
      window.open(
        `${baseurl1}uploads/images/${ImageName}`,
        "_blank"
      );
    } else {
      // optional: show message
      // toast.error("Please upload file");
      console.warn("No image available");
    }
  }}
                            >
                              View
                            </Button>
                          </Box>
                        </FormControl>
                      </FormControl>
                    </Box>
                  </Box>
                  {/* </FormControl> */}
                  <Box
                    display="flex"
                    padding={1}
                    justifyContent="end"
                    // mt="70px"
                    gap={2}
                  >
                    {/* {YearFlag == "true" ? ( */}
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={isLoading}
                      disabled
                    >
                      Save
                    </LoadingButton>
                    {/* ) : (
                            <Button
                              color="secondary"
                              variant="contained"
                              disabled={true}
                            >
                              Save
                            </Button>
                          )}
                          {YearFlag == "true" ? ( */}
                    <Button
                      onClick={() => FnAttachment(values, resetForm, true)}
                      color="error"
                      variant="contained"
                      disabled
                    >
                      Delete
                    </Button>
                    {/* ) : (
                            <Button color="error" variant="contained" disabled={true}>
                              Delete
                            </Button>
                          )} */}
                    <Button
                      type="reset"
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        setScreen(0);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </form>
              )}
            </Formik>
            {/* </Box> */}
          </Paper>
        ) : (
          false
        )}
        {show == "9" ? (
          <Paper elevation={3} sx={{ margin: "10px" }}>
            <Formik
              initialValues={deploymentInitialValue}
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                setTimeout(() => {
                  FndeploymentApprovals(values, resetForm, false);
                }, 100);
              }}
            >
              {({
                errors,
                touched,
                handleBlur,
                handleChange,
                isSubmitting,
                values,
                handleSubmit,
                resetForm,
                setFieldValue,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  onReset={() => {
                    selectCellRowData({ rowData: {}, mode: "A", field: "" });
                    resetForm();
                  }}
                >
                  <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                    // gap="30px"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 2",
                      },
                    }}
                  >
                    <FormControl sx={{ gap: formGap }}>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="code"
                        name="code"
                        value={values.code}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Code"
                        sx={{
                          gridColumn: "span 2",
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                          },
                        }}
                        focused
                        inputProps={{ readOnly: true }}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="description"
                        name="description"
                        value={values.description}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Name"
                        sx={{
                          //gridColumn: "span 2",
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                          },
                        }}
                        focused
                        inputProps={{ readOnly: true }}
                      />
                    </FormControl>
                  </Box>
                  {/* <Box display="flex" flexDirection="column" gap={2}> */}
                  {/* Row 1: Horizontal */}
                  <Box display="flex" flexDirection="column" gap={2}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Field
                        type="checkbox"
                        id="Horizontal"
                        name="Horizontal"
                        // onChange={handleChange}
                        disabled
                        // onBlur={handleBlur}
                        as={Checkbox}
                        label="Horizontal"
                      />
                      <FormLabel focused={false}>Horizontal</FormLabel>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="number"
                        id="HorizontalMimNo"
                        name="HorizontalMimNo"
                        value={values.HorizontalMimNo}
                        inputProps={{ readOnly: true }}
                        onBlur={handleBlur}
                        // onChange={handleChange}

                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^[012345]?$/.test(val)) {
                            handleChange(e); // only allow '', '1', '2', or '3'
                          }
                        }}
                        label="Minimum managers to approve (0 for all managers)"
                        // label="No of levels to approve"
                        sx={{
                          width: "400px",
                          marginLeft: "30px",
                          //gridColumn: "span 2",
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                          },
                        }}
                        focused
                        // InputProps={{
                        //   inputProps: {
                        //     style: { textAlign: "right" },
                        //   },
                        // }}
                        InputProps={{
                          inputProps: {
                            style: { textAlign: "right" },
                            min: 0,
                            max: 5,
                          },
                        }}
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            "0",
                            "1",
                            "2",
                            "3",
                            "4",
                            "5",
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                          ];
                          if (!allowedKeys.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Box>

                    {/* Row 2: Vertical */}
                    <Box display="flex" alignItems="center" gap={1}>
                      <Field
                        type="checkbox"
                        id="Vertical"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="Vertical"
                        as={Checkbox}
                        label="Vertical"
                        disabled
                      />
                      <FormLabel focused={false}>Vertical</FormLabel>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="number"
                        id="VerticalMimNo"
                        name="VerticalMimNo"
                        value={values.VerticalMimNo}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^[123]?$/.test(val)) {
                            handleChange(e); // only allow '', '1', '2', or '3'
                          }
                        }}
                        label="No of levels to approve(minimum level of 3)"
                        // label="Minimum managers to approve (0 for all managers)"
                        sx={{
                          width: "400px",
                          marginLeft: "47px",
                          //gridColumn: "span 2",
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                          },
                        }}
                        focused
                        // InputProps={{
                        //   inputProps: {
                        //     style: { textAlign: "right" },
                        //   },
                        // }}

                        InputProps={{
                          inputProps: {
                            readOnly: true,
                            style: { textAlign: "right" },
                            min: 1,
                            max: 3,
                          },
                        }}
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            "1",
                            "2",
                            "3",
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                          ];
                          if (!allowedKeys.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Box>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="column"
                    marginTop={1}
                    gap={2}
                  >
                    {/* First AutoApprovalYesOrNo Checkbox */}
                    <Box display="flex" alignItems="center" gap={1}>
                      <Field
                        type="checkbox"
                        id="AutoApprovalYesOrNo"
                        name="AutoApprovalYesOrNo"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        as={Checkbox}
                        disabled
                      />
                      <FormLabel focused={false}>Auto Approval</FormLabel>

                      <TextField
                        fullWidth
                        variant="standard"
                        type="number"
                        id="ApprovelTolerance"
                        name="ApprovelTolerance"
                        value={values.ApprovelTolerance}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        //                        onChange={(e) => {
                        //   const val = e.target.value;
                        //   if (/^[123]?$/.test(val)) {
                        //     handleChange(e); // only allow '', '1', '2', or '3'
                        //   }
                        // }}
                        label="Tolerance days"
                        sx={{
                          width: "400px",
                          marginLeft: "10px",
                          //gridColumn: "span 2",
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                          },
                        }}
                        focused
                        // InputProps={{
                        //   inputProps: {
                        //     style: { textAlign: "right" },
                        //   },
                        // }}

                        InputProps={{
                          readOnly: true,
                          inputProps: {
                            style: { textAlign: "right" },
                            min: 1,
                            max: 3,
                          },
                        }}
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            "1",
                            "2",
                            "3",
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                          ];
                          if (!allowedKeys.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Box>

                    {/* Second AutoRejectionYesOrNo Checkbox */}
                    <Box display="flex" alignItems="center" gap={1}>
                      <Field
                        type="checkbox"
                        id="AutoRejectionYesOrNo"
                        name="AutoRejectionYesOrNo"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        as={Checkbox}
                        disabled
                      />
                      <FormLabel focused={false}>Auto Rejection</FormLabel>

                      <TextField
                        fullWidth
                        variant="standard"
                        type="number"
                        id="RejectionTolerance"
                        name="RejectionTolerance"
                        value={values.RejectionTolerance}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Tolerance days"
                        sx={{
                          width: "400px",
                          marginLeft: "10px",
                          //gridColumn: "span 2",
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                          },
                        }}
                        focused
                        InputProps={{
                          readOnly: true,
                          inputProps: {
                            style: { textAlign: "right" },
                          },
                        }}
                      />
                    </Box>
                  </Box>

                  <Box
                    display="flex"
                    justifyContent="end"
                    mt="30px"
                    padding={1}
                    gap={2}
                  >
                    {/* {YearFlag == "true" ? (
                      <LoadingButton
                        color="secondary"
                        variant="contained"
                        type="submit"
                        loading={isLoading}
                      >
                        Save
                      </LoadingButton>
                    ) : ( */}
                    <Button
                      color="secondary"
                      variant="contained"
                      disabled={true}
                    >
                      Save
                    </Button>
                    {/* )} */}
                    {/* {YearFlag == "true" ? ( */}
                    {/* <Button
                        color="error"
                        variant="contained"
                        onClick={() => {
                          fnSave(values, "harddelete");
                        }}
                      >
                        Delete
                      </Button> */}
                    {/* ) : ( */}
                    <Button color="error" variant="contained" disabled={true}>
                      Delete
                    </Button>
                    {/* )} */}
                    {/* {YearFlag == "true" ? (
                      <Button
                        onClick={() => mgrFunctionFn(values, resetForm, true)}
                        color="error"
                        variant="contained"
                      >
                        Delete
                      </Button>
                    ) : (
                      <Button color="error" variant="contained" disabled={true}>
                        Delete
                      </Button>
                    )} */}
                    <Button
                      type="reset"
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        setScreen(0);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>

                  <Popup
                    title="Location"
                    openPopup={openLOCATIONPopup}
                    setOpenPopup={setOpenLOCATIONPopup}
                  >
                    <Listviewpopup
                      accessID="2051"
                      screenName="Location"
                      childToParent={childToParent}
                      filterName={"parentID"}
                      filterValue={compID}
                    />
                  </Popup>
                  <Popup
                    title="Gate"
                    openPopup={openGATEPopup}
                    setOpenPopup={setOpenGATEPopup}
                  >
                    <Listviewpopup
                      accessID="2050"
                      screenName="Gate"
                      filterName={"parentID"}
                      // filterValue={locationLookup.locationRecordID}
                      childToParent={childToParent}
                    />
                  </Popup>
                  <Popup
                    title="Designation"
                    openPopup={opendesignPopup}
                    setOpenPopup={setOpendesignPopup}
                  >
                    <Listviewpopup
                      accessID="2047"
                      screenName="Designation"
                      childToParent={childToParent}
                      filterName={"parentID"}
                      filterValue={compID}
                    />
                  </Popup>
                  {/* <Popup
                    title="CheckIn"
                    openPopup={openCHECKINPopup}
                    setOpenPopup={setOpenCHECKINPopup}
                  >
                    <Listviewpopup
                      accessID=""
                      screenName="CheckIn"
                      childToParent={childToParent}
                    />
                  </Popup> */}
                </form>
              )}
            </Formik>
          </Paper>
        ) : (
          false
        )}
        {show == "7" ? (
          <Paper elevation={3} sx={{ margin: "10px" }}>
            {/* <Box m="10px"> */}
            <Formik
              initialValues={itemcustodyInitialValue}
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                setTimeout(() => {
                  empItemCustodyFn(values, resetForm, false);
                }, 100);
              }}
            >
              {({
                errors,
                touched,
                handleBlur,
                handleChange,
                isSubmitting,
                values,
                handleSubmit,
                resetForm,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  onReset={() => {
                    selectCellRowData({ rowData: {}, mode: "A", field: "" });
                    resetForm();
                  }}
                >
                  <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 4",
                      },
                    }}
                  >
                    <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="code"
                        name="code"
                        value={values.code}
                        label="Code"
                        focused
                        inputProps={{ readOnly: true }}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="description"
                        name="description"
                        value={values.description}
                        label="Description"
                        focused
                        inputProps={{ readOnly: true }}
                      />
                    </FormControl>
                    {isNonMobile && (
                      <Stack
                        sx={{
                          //    width: {sm:'100%',md:'100%',lg:'100%'},
                          gridColumn: "span 2",
                          alignContent: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          right: "0px",
                        }}
                      >
                        <Avatar
                          variant="rounded"
                          src={userimg}
                          sx={{ width: "200px", height: "150px" }}
                        />
                      </Stack>
                    )}

                    <Box sx={{ gridColumn: "span 2" }}>
                      <Box
                        // height={dataGridHeight}
                        height="350px"
                        sx={{
                          "& .MuiDataGrid-root": {
                            // border: "none",
                          },
                          "& .MuiDataGrid-cell": {
                            // borderBottom: "none",
                          },
                          "& .name-column--cell": {
                            color: colors.greenAccent[300],
                          },
                          "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: colors.blueAccent[800],
                            // borderBottom: "none",
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            backgroundColor: colors.primary[400],
                          },
                          "& .MuiDataGrid-footerContainer": {
                            // borderTop: "none",
                            backgroundColor: colors.blueAccent[800],
                          },
                          "& .MuiCheckbox-root": {
                            color: `${colors.greenAccent[200]} !important`,
                          },
                          "& .odd-row": {
                            backgroundColor: "",
                            color: "", // Color for odd rows
                          },
                          "& .even-row": {
                            backgroundColor: "#d0edec",
                            color: "", // Color for even rows
                          },
                        }}
                      >
                        <DataGrid
                          sx={{
                            "& .MuiDataGrid-footerContainer": {
                              height: dataGridHeaderFooterHeight,
                              minHeight: dataGridHeaderFooterHeight,
                            },
                          }}
                          rowHeight={dataGridRowHeight}
                          headerHeight={dataGridHeaderFooterHeight}
                          // checkboxSelection
                          rows={explorelistViewData}
                          columns={columns}
                          disableSelectionOnClick
                          getRowId={(row) => row.RecordID}
                          pageSize={pageSize}
                          onPageSizeChange={(newPageSize) =>
                            setPageSize(newPageSize)
                          }
                          onCellClick={(params) => {
                            selectCellRowData({
                              rowData: params.row,
                              mode: "E",
                              field: params.field,
                            });
                          }}
                          rowsPerPageOptions={[5, 10, 20]}
                          pagination
                          components={{
                            Toolbar: Employee,
                          }}
                          onStateChange={(stateParams) =>
                            setRowCount(stateParams.pagination.rowCount)
                          }
                          loading={exploreLoading}
                          componentsProps={{
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                            },
                          }}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "odd-row"
                              : "even-row"
                          }
                        />
                      </Box>
                    </Box>
                    <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        value={values.ItemNumber}
                        id="ItemNumber"
                        name="ItemNumber"
                        label="item No"
                        required
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.ItemNumber && !!errors.ItemNumber}
                        helperText={touched.ItemNumber && errors.ItemNumber}
                        sx={{
                          gridColumn: "span 2",
                        }}
                        focused
                        multiline
                        inputProps={{ maxLength: 90, readOnly: true }}
                      />
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        value={values.ItemName}
                        id="ItemName"
                        name="ItemName"
                        label="Item Name"
                        required
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.ItemName && !!errors.ItemName}
                        helperText={touched.ItemName && errors.ItemName}
                        sx={{
                          gridColumn: "span 2",
                        }}
                        focused
                        multiline
                        inputProps={{ maxLength: 90 }}
                        InputProps={{ readOnly: true }}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        value={values.AssestID}
                        id="AssestID"
                        name="AssestID"
                        label="Assest ID"
                        required
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.AssestID && !!errors.AssestID}
                        helperText={touched.AssestID && errors.AssestID}
                        sx={{
                          gridColumn: "span 2",
                        }}
                        focused
                        multiline
                        inputProps={{ maxLength: 90 }}
                        InputProps={{ readOnly: true }}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        value={values.ItemValue}
                        id="ItemValue"
                        name="ItemValue"
                        label="Item Value"
                        required
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.ItemValue && !!errors.ItemValue}
                        helperText={touched.ItemValue && errors.ItemValue}
                        sx={{
                          gridColumn: "span 2",
                        }}
                        focused
                        multiline
                        inputProps={{ maxLength: 90 }}
                        InputProps={{ readOnly: true }}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        value={values.PurchaseReference}
                        id="PurchaseReference"
                        name="PurchaseReference"
                        label="Reference"
                        required
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={
                          !!touched.PurchaseReference &&
                          !!errors.PurchaseReference
                        }
                        helperText={
                          touched.PurchaseReference && errors.PurchaseReference
                        }
                        sx={{
                          gridColumn: "span 2",
                        }}
                        focused
                        multiline
                        inputProps={{ maxLength: 90 }}
                        InputProps={{ readOnly: true }}
                      />
                    </FormControl>
                  </Box>
                  <Box
                    display="flex"
                    padding={1}
                    justifyContent="end"
                    // mt="20px"
                    gap={2}
                  >
                    {/* {YearFlag == "true" ? ( */}
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={isLoading}
                      disabled
                    >
                      Save
                    </LoadingButton>
                    {/* ) : (
                      <Button
                        color="secondary"
                        variant="contained"
                        disabled={true}
                      >
                        Save
                      </Button>
                    )}
                    {YearFlag == "true" ? ( */}
                    <Button
                      onClick={() => empItemCustodyFn(values, resetForm, true)}
                      color="error"
                      variant="contained"
                      disabled
                    >
                      Delete
                    </Button>
                    {/* ) : (
                      <Button color="error" variant="contained" disabled={true}>
                        Delete
                      </Button>
                    )} */}
                    <Button
                      type="reset"
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        setScreen(0);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                  <Popup
                    title="Functions"
                    openPopup={openFunPopup}
                    setOpenPopup={setOpenFunPopup}
                  >
                    <Listviewpopup
                      accessID="2048"
                      screenName="Functions"
                      childToParent={childToParent}
                    />
                  </Popup>
                  <Popup
                    title="Designations"
                    openPopup={openDesPopup}
                    setOpenPopup={setOpenDesPopup}
                  >
                    <Listviewpopup
                      accessID="2049"
                      screenName="Designations"
                      childToParent={childToParent}
                      filterName={"Rank"}
                      filterValue={Data.Rank}
                    />
                  </Popup>
                </form>
              )}
            </Formik>
            {/* </Box> */}
          </Paper>
        ) : (
          false
        )}
        {show == "8234324" ? (
          <Paper elevation={3} sx={{ margin: "10px" }}>
            {/* <Box m="10px"> */}
            <Formik
              initialValues={[]}
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                setTimeout(() => {
                  empItemCustodyFn(values, resetForm, false);
                }, 100);
              }}
            >
              {({
                errors,
                touched,
                handleBlur,
                handleChange,
                isSubmitting,
                values,
                handleSubmit,
                resetForm,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  onReset={() => {
                    selectCellRowData({ rowData: {}, mode: "A", field: "" });
                    resetForm();
                  }}
                >
                  <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                    // gap="30px"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 2",
                      },
                    }}
                  >
                    <FormControl sx={{ gap: formGap }}>
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="currentpassword"
                        name="currentpassword"
                        value={values.currentpassword}
                        label="Current Password"
                        focused
                        // inputProps={{ readOnly: true }}
                      />

                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="newpassword"
                        name="newpassword"
                        value={values.newpassword}
                        label="New Password"
                        focused
                        //inputProps={{ readOnly: true }}
                      />
                      <TextField
                        fullWidth
                        variant="standard"
                        type="text"
                        id="confirmpassword"
                        name="confirmpassword"
                        value={values.confirmpassword}
                        label="Confirm Password"
                        focused
                        //inputProps={{ readOnly: true }}
                      />
                    </FormControl>
                  </Box>
                  <Box
                    display="flex"
                    padding={1}
                    justifyContent="end"
                    mt="30px"
                    gap={2}
                  >
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={isLoading}
                    >
                      Save
                    </LoadingButton>

                    <Button
                      type="reset"
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        setScreen(0);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </form>
              )}
            </Formik>
            {/* </Box> */}
          </Paper>
        ) : (
          false
        )}





      </Box>
    </React.Fragment>
  );
};

export default Editemployee;
